/* Luhxe Campaign Link Handler  (Shrine PRO)
   Inert unless the URL carries campaign params. Reads:
     lxpromo = discount code (display; cookie is set by the /discount/CODE redirect wrapper)
               The code NAME is never shown on the page (21 Oct 2026, Arvin: shoppers would reuse or share it).
     lxpct   = percent off (e.g. 10)      -> dynamic price
     lxamt   = cents off  (e.g. 2000)     -> dynamic price
     lxgifts = comma variant ids to auto-add free
     lxnames = pipe-separated gift names for the banner
   Added 2 Sep 2026 (Brian Kim's Loom):
     lxsale    = the SALE NAME, shown as a badge by the title and in the banner, so a
                 campaign link is visibly "National Beach Day Sale" WITHOUT duplicating
                 the product just to rename it. This is the whole point of the tool.
     lxuntil   = ISO datetime the sale ends -> live countdown; after it the campaign
                 goes inert (no gift, no banner) instead of quietly running forever.
     lxfrom    = ISO datetime the sale starts (optional) -> inert before it.
     lxdrop    = comma variant ids to keep OUT of the cart (an app on this store auto-adds
                 a $19 Traveler's Guide nobody asked for; a campaign can refuse it).
     lxgiftfor = comma list of OPTION VALUES the gift applies to (e.g. "Rose,Snow").
     lxtagpick = 1 -> the Find My tag in lxgifts is shown with a Rose / Snow / Black picker in
                 the banner; the customer's pick swaps the cart line (Arvin, 15 Oct 2026).
     lxbogo    = 1 -> Buy 1 Get 1 Free (21 Oct 2026). The price is the code in lxpromo; this
                 only makes the 2-bag bar, the buy buttons and the sticky bar say it.
     lxbadge   = 0 -> no black sale-name badge above the product title (Arvin, 22 Oct 2026: "lets remove
                 this"). The sale name still shows in the deal heading, the top bar, the banner and the tab.
     lxtopbar  = 1 -> the top bar shows ONLY the sale name, still (no scrolling), regular weight; the store's
                 usual messages there ("Up to 60% Off", "Over 100,000+ Sold") are left out (Chris, 22 Oct 2026).
     lxlowstock = 0 -> hide the red blinking "Warning: Low Stock Remaining" line under Add to Cart (Chris, 22 Oct).
     lxbanner  = 0 -> hide our gift / code banner above Add to Cart (Chris, 22 Oct: "lets remove these").
     lxoffer   = "Title|Red part" -> Chris's offer box in place of the Low Stock line (his HTML and CSS, 22 Oct), e.g.
                 "Halloween Sale: BOGO +|$102 in FREE Gifts!". lxclaim = "846/1000" adds his "Gifts claimed" bar.
                 The claimed number is whatever the link says; it does not count anything.
     lxgiftstrip = 1 -> a row of the free gifts (FREE pill, picture, name, value) under the Add to Cart
                 button (Chris, 22 Oct 2026). Only gifts this link actually adds are shown.
     lxgiftper = 1 -> one gift PER qualifying bag in the cart (capped at 10), instead of
                 one per order. Opt-in, so links already sent keep the old behaviour.
                 The gift is added only while the chosen variant matches, and is
                 REMOVED again if they switch to one that does not (Labor Day: free
                 cosmetic bag on pink/white, never on black).
   Shows: (1) a clear "code applied" + "free gift added" banner near the price,
          (2) a dynamic "Your price $X" line, recomputed on variant change.
   Everything is best-effort and wrapped in try/catch; never blocks the page. */
// OLD BUY 1 GET 1 LINKS (21 Oct 2026, 10 PM). Chris re-priced Buy 1 Get 1 to $179 Classic / $279 Roller for 1 OR 2 bags.
// A discount cannot raise /products/luhxe's $129 Classic, so Buy 1 Get 1 moved to its own copy of the bag,
// 03 Nov 2026 (Chris, Loom "shut down the frontend MR"): Protection+ is OFF on the front end. A shopper who put the membership in
// the cart before today still has it there, so on any page, once per page view, every Luhxe Protection+ line (any arm, matched by
// product handle) is taken out of the cart, with the free Find My tag that came with it. Bags and gifts stay. ?lxppkeep=1 skips it.
(function () {
  try {
    if (/[?&]lxppkeep=1(&|$)/.test(location.search)) return;
    if (!/(^|;\s*)cart=/.test(document.cookie)) return;
    var isPP = function (it) { return /^(luhxe-protection-plus|luhxe-24-7-concierge$)/.test(it.handle || '') || /^find-my-tag/.test(it.handle || '') && it.final_line_price === 0 && it.properties && (it.properties._protection_plus_cohort || it.properties['Included with']); };
    fetch('/cart.js', { credentials: 'same-origin', __lx: true }).then(function (r) { return r.json(); }).then(function (cart) {
      var upd = {}, n = 0;
      (cart.items || []).forEach(function (it) { if (isPP(it)) { upd[it.key] = 0; n++; } });
      if (!n) return;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', __lx: true,
        body: JSON.stringify({ updates: upd, sections: 'cart-drawer,cart-icon-bubble,cart-live-region-text' }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.sections && window.lxSwapSections) window.lxSwapSections(c.sections); });
    }).catch(function () {});
  } catch (e) {}
})();
// /products/luhxe-travel-bag-2-0-halloween-bogo, sold by its Kaching deal with no code (HALLOWEENBOGO is expired).
// A link built before that (/products/luhxe?...&lxpromo=HALLOWEENBOGO&lxbogo=1) would show the old $129 here and
// charge $179 at the cart, so it is sent to the new page with its other settings (gifts, sale name, title) kept.
(function () {
  try {
    var m = location.pathname.match(/^(.*\/products\/)luhxe\/?$/);
    if (!m) return;
    var oq = new URLSearchParams(location.search);
    if (!/^(1|true|yes)$/i.test(oq.get('lxbogo') || '')) return;
    oq.delete('lxbogo'); oq.delete('lxpromo');
    var qs = oq.toString();
    location.replace(m[1] + 'luhxe-travel-bag-2-0-halloween-bogo' + (qs ? '?' + qs : '') + location.hash);
  } catch (e) {}
})();

// HALLOWEEN SALE BAG FIRST IN THE CART (28 Oct 2026, Chris: "make the bag the first item on the top"). Shopify lists the
// newest line first and the Protection+ membership and gifts go in after the bag, so the bag sat at the bottom. CSS order only:
// each drawer row keeps its own line number, so remove and quantity controls are untouched. Site-wide because the drawer is.
(function () {
  try {
    var st = document.createElement('style'); st.id = 'lx-cart-bag-first';
    st.textContent = 'cart-drawer ul.cart-items>li[class*="cart-item--product-luhxe-travel-bag-2-0-halloween-sale"],cart-drawer ul.cart-items>li[class*="cart-item--product-luhxe-travel-bag-2-0-early-black-friday"],cart-drawer ul.cart-items>li[class*="cart-item--product-luhxe-travel-bag-2-0-black-friday"]{order:-1}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
})();

// HALLOWEEN BUY 1 GET 1 PAGE: the store's own Add to Cart look (22 Oct 2026, Chris: "button broken as well, doesn't look
// like the other one"). The theme's preorder-manager.js turns the page's button into "ADD TO CART - $400 $179 / In-Stock:
// Ready to Ship" and adds the sticky Add to Cart bar, but ONLY for handles in its own PRODUCTS map, and this copy of the bag
// is not in it, so it kept the bare GemPages button. Register it here instead of editing that file (another developer
// maintains it). Same shape as its 'luhxe' entry: this product's variant ids and its own Kaching bar ids (Buy 1 / Buy 1 Get 1).
// Clicks still go through the page's own button, so Kaching adds the bags with its deal exactly as before.
(function () {
  try {
    // 23 Oct 2026: the Halloween 4-gifts page (no Buy 1 Get 1, Chris) is registered the same way, with its own bars.
    // It was last year's National Girlfriends Day copy; EasyGift still adds 2 Luhxe Cosmetic Bags (43136402358319) to a
    // 2-bag cart there, so its built-in settings drop that item (lxdrop).
    var PAGES = {
      // 26 Oct 2026: a second copy of the Buy 1 Get 1 page (-em), same Kaching deal and bars, its own variant ids.
      'luhxe-travel-bag-2-0-halloween-bogo-em': {
        IDS: {
          Rose:     { 'Roller Edition': '47061798420527', Classic: '47061798387759' },
          Charcoal: { 'Roller Edition': '47061798486063', Classic: '47061798453295' },
          Snow:     { 'Roller Edition': '47061798551599', Classic: '47061798518831' }
        },
        SINGLE_ID: '104d0eca-04c0-42dd-89fc-ca8216d34c37',
        DOUBLE_ID: 'f8de9b70-2242-492b-b0c6-6f32c79b721c',
        colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
      },
      'luhxe-travel-bag-2-0-halloween-sale': {
        IDS: {
          Rose:     { 'Roller Edition': '45692401188911', Classic: '45692401156143' },
          Charcoal: { 'Roller Edition': '45692401254447', Classic: '45692401221679' },
          Snow:     { 'Roller Edition': '45692401319983', Classic: '45692401287215' }
        },
        SINGLE_ID: '7c427d27-b464-431e-afd8-bda3b103babb',
        DOUBLE_ID: '3d5bc398-8bbd-4734-b809-d47f3d38f0a8',
        colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
      },
      // 30 Oct 2026: Early Black Friday page (copy of the Halloween Sale page, its own Kaching deal e9f7bc5b).
      'luhxe-travel-bag-2-0-early-black-friday': {
        IDS: {
          Rose:     { 'Roller Edition': '47093505490991', Classic: '47093505458223' },
          Charcoal: { 'Roller Edition': '47093505556527', Classic: '47093505523759' },
          Snow:     { 'Roller Edition': '47093505622063', Classic: '47093505589295' }
        },
        SINGLE_ID: '7f7886f7-a065-42f4-aea7-1e2f839b303c',
        DOUBLE_ID: '3fc1b252-b81c-47f7-8871-a99422757c63',
        colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
      },
      // 30 Oct 2026: Early Black Friday Buy 1 Get 1 email page (copy of -em, its own Kaching deal ff801fe6).
      'luhxe-travel-bag-2-0-early-black-friday-bogo': {
        IDS: {
          Rose:     { 'Roller Edition': '47095205560367', Classic: '47095205527599' },
          Charcoal: { 'Roller Edition': '47095205625903', Classic: '47095205593135' },
          Snow:     { 'Roller Edition': '47095205691439', Classic: '47095205658671' }
        },
        SINGLE_ID: '9b9e4f02-f19e-4e9d-9177-21f1777b18ed',
        DOUBLE_ID: 'bc645f00-5735-48f2-b664-8ce96768f650',
        colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
      },
      // 03 Nov 2026: Black Friday page (11/11), copy of the Early Black Friday page, its own Kaching deal be5fe00a.
      'luhxe-travel-bag-2-0-black-friday': {
        IDS: {
          Rose:     { 'Roller Edition': '47115100815407', Classic: '47115100782639' },
          Charcoal: { 'Roller Edition': '47115100880943', Classic: '47115100848175' },
          Snow:     { 'Roller Edition': '47115100946479', Classic: '47115100913711' }
        },
        SINGLE_ID: 'af0a65d9-b861-4eb9-b000-0645444ab2e8',
        DOUBLE_ID: '6c223d17-cca3-4a94-892b-dc74a71feca3',
        colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
      },
      // 03 Nov 2026: Black Friday Buy 1 Get 1 email/SMS page, copy of the Early Black Friday BOGO page, Kaching deal 9d91a28b.
      'luhxe-travel-bag-2-0-black-friday-bogo': {
        IDS: {
          Rose:     { 'Roller Edition': '47115101798447', Classic: '47115101765679' },
          Charcoal: { 'Roller Edition': '47115101863983', Classic: '47115101831215' },
          Snow:     { 'Roller Edition': '47115101929519', Classic: '47115101896751' }
        },
        SINGLE_ID: 'f1046fbe-3087-40a9-9347-cd5535152eea',
        DOUBLE_ID: 'a7505aae-e054-4288-afee-975819b90001',
        colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
      }
    };
    var H = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
    if (H !== 'luhxe-travel-bag-2-0-halloween-bogo' && !PAGES[H]) return;
    var pm = window.PreorderManager;
    if (!pm || !pm.PRODUCTS || pm.PRODUCTS[H]) return;   // an entry of their own wins
    pm.PRODUCTS[H] = PAGES[H] || {
      IDS: {
        Rose:     { 'Roller Edition': '43442570723375', Classic: '43442570690607' },
        Charcoal: { 'Roller Edition': '43442570788911', Classic: '43442570756143' },
        Snow:     { 'Roller Edition': '43442570854447', Classic: '43442570821679' }
      },
      SINGLE_ID: '104d0eca-04c0-42dd-89fc-ca8216d34c37',
      DOUBLE_ID: 'f8de9b70-2242-492b-b0c6-6f32c79b721c',
      colorStock: { Rose: 'available', Charcoal: 'available', Snow: 'available' }
    };
    // Its auto-start calls init() at DOMContentLoaded, after this deferred script. If it already ran (and skipped this
    // page), start it once more. Never twice.
    var orig = pm.init, ran = false;
    pm.init = function () { if (ran) return this; ran = true; return orig.apply(this, arguments); };
    var kick = function () { if (!ran) { try { pm.init(); } catch (e) {} } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(kick, 400); });
    else setTimeout(kick, 400);
  } catch (e) {}
})();

// DEFAULT OFFER GUARD (21 Oct 2026). Product 8322360999983 (/products/luhxe-travel-bag-2-0-special-offer) was
// the July 4th clone and EasyGift still runs its July rule on it: a Traveler's Guide, a Shoe Bag and a Cosmetic Bag
// are auto-added free. It is now the builder's default offer, so those never go in, for ANY visitor (before a sale
// starts, after it ends, or with no link at all). Only these three variants, and only their $0 gift lines.
(function () {
  try {
    var pm = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!pm || String(pm.id) !== '8322360999983') return;
    var EG = ['43134073045039', '42128545251375', '43136402358319'];
    // 21 Oct 2026 (evening): this product is titled "Luhxe Travel Bag 2.0 (Special Offer)" so the bundle app's
    // product picker can tell it from the main page's product. Both were "Luhxe Travel Bag 2.0", and a deal meant
    // for this page landed on the main one. Shoppers still read the plain name; a link's lxtitle still wins.
    try {
      var cleanTitle = function () {
        var hs = document.querySelectorAll('h1, .product__title, [class*="product-title" i], [class*="product_title" i]');
        for (var i = 0; i < hs.length; i++) {
          var w = document.createTreeWalker(hs[i], NodeFilter.SHOW_TEXT, null), n;
          while ((n = w.nextNode())) { if (/^\s*luhxe travel bag 2\.0 \(special offer\)\s*$/i.test(n.nodeValue || '')) n.nodeValue = n.nodeValue.replace(/\s*\(special offer\)/i, ''); }
        }
      };
      if (document.readyState !== 'loading') cleanTitle(); else document.addEventListener('DOMContentLoaded', cleanTitle);
      setTimeout(cleanTitle, 800); setTimeout(cleanTitle, 2500); setTimeout(cleanTitle, 6000);
    } catch (e) {}
    // The July design's "4 free gifts" box (Guide, Shoe Bag, $24 Gift Card, Cosmetic Bag) is not the offer any
    // more (Arvin, 21 Oct: "remove that 4 items display"). Hidden by its GemPages id, and by its contents if the
    // design is ever republished with new ids: the smallest gp-row holding all four names and no buy button.
    try {
      var st = document.createElement('style');
      // The design ships its own "body #gCpY6hquA7{display:block!important}", so this must outrank it.
      st.textContent = 'html body #gCpY6hquA7#gCpY6hquA7{display:none!important}';
      (document.head || document.documentElement).appendChild(st);
      var NEED = [/travel savings guide/i, /shoe bag/i, /gift card/i, /cosmetic bag/i];
      var hideBox = function () {
        var q = [];
        document.querySelectorAll('gp-row').forEach(function (g) {
          var t = g.textContent || '';
          if (t.length > 1500 || /add to cart/i.test(t) || g.querySelector('.kaching-bundles, form[action*="/cart/add"]')) return;
          for (var i = 0; i < NEED.length; i++) if (!NEED[i].test(t)) return;
          q.push(g);
        });
        // the OUTER box (the one holding every other match), so its border and padding go too
        var top = q.filter(function (g) { return q.every(function (o) { return o === g || g.contains(o); }); })[0];
        if (top && top.style.getPropertyValue('display') !== 'none') top.style.setProperty('display', 'none', 'important');
      };
      if (document.readyState !== 'loading') hideBox(); else document.addEventListener('DOMContentLoaded', hideBox);
      setTimeout(hideBox, 1500); setTimeout(hideBox, 5000);
    } catch (e) {}
    var of = window.fetch, t = null;
    var sweep = function () {
      of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var chain = Promise.resolve();
        (c.items || []).forEach(function (it) {
          if (EG.indexOf(String(it.variant_id)) !== -1 && (it.final_line_price || 0) === 0)
            chain = chain.then(function () { return of('/cart/change.js', { method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) }); });
        });
      }).catch(function () {});
    };
    window.fetch = function (input, init) {
      try {
        var u = String((input && input.url) || input || '');
        if (/\/cart\/add/.test(u) && /_easygift_internal/.test(u))
          return Promise.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        if (/\/cart\/(add|change|update)/.test(u)) { clearTimeout(t); t = setTimeout(sweep, 1800); }
      } catch (e) {}
      return of.apply(this, arguments);
    };
    sweep(); setTimeout(sweep, 6000);
    var n = 0, iv = setInterval(function () { if (++n > 40) return clearInterval(iv); sweep(); }, 5000);  // ~3 min, read-only unless a July gift is there
  } catch (e) {}
})();
// CART REDRAW THAT KEEPS THE CART OPEN (23 Oct 2026, Chris: "it exited my cart"). Our old redraw swapped the whole
// cart-drawer section, which replaced the <cart-drawer> element that holds the open state, so every cart change we
// made shut the cart (measured on the Halloween link: open at +6.5s after Add to Cart, shut at +8.3s when the gifts
// went in). Open drawer: hand the fresh sections to the theme's own renderContents, the same call it makes after its
// own cart updates. Closed drawer: swap only what is inside #CartDrawer, as the theme does, so the element (its open
// state, and anything watching it) is never replaced.
window.lxSwapSections = function (secs) {
  secs = secs || {};
  var cd = document.querySelector('cart-drawer'), done = {};
  if (cd && secs['cart-drawer']) {
    if (cd.classList.contains('active') && typeof cd.renderContents === 'function') {
      try { cd.renderContents({ id: cd.productId, sections: secs }); done['cart-drawer'] = done['cart-icon-bubble'] = 1; } catch (e) {}
    }
    if (!done['cart-drawer']) {   // closed (or the theme call failed): never replace the <cart-drawer> element itself
      try {   // fallback: swap only what is inside #CartDrawer, as the theme does, and keep the element
        var cur = document.getElementById('CartDrawer'), doc0 = new DOMParser().parseFromString(secs['cart-drawer'], 'text/html'), nu = doc0.getElementById('CartDrawer');
        if (cur && nu) {
          cur.innerHTML = nu.innerHTML;
          var ncd = doc0.querySelector('cart-drawer'); if (ncd) cd.classList.toggle('is-empty', ncd.classList.contains('is-empty'));
          var ov = cd.querySelector('#CartDrawer-Overlay'); if (ov && typeof cd.close === 'function') ov.addEventListener('click', cd.close.bind(cd));
          done['cart-drawer'] = 1;
        }
      } catch (e) {}
    }
  }
  Object.keys(secs).forEach(function (k) {
    if (done[k] || typeof secs[k] !== 'string') return;
    var host = document.getElementById('shopify-section-' + k);
    if (!host) return;
    try {
      var doc = new DOMParser().parseFromString(secs[k], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + k);
      host.innerHTML = fresh ? fresh.innerHTML : secs[k];
    } catch (e) {}
  });
  try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
};
(function () {
  try {
    var q = new URLSearchParams(location.search);
    // 23 Oct 2026 (Chris: "that query string at end of link is too long"; Hichem: "remove all query params and you won't
    // see any widget"). A product made for one campaign now carries that campaign itself, so its plain address is the
    // whole offer and a split test or a redirect can point at it. A link with its own lx settings still wins.
    // 24 Oct 2026 (Chris): normal prices ($129 / $179) and "BOGO 50% Off + 4 FREE Gifts". The 2-bag discount comes from this
    // page's own Kaching deal, which only the team can edit, so the BOGO wording is used ONLY once that deal's 2-bag bar
    // really discounts (window.lxDeal2Discounts). Until then the page keeps the 4-gifts wording, never promising 50% it
    // would not ring.
    window.lxDeal2Discounts = function () {
      try {
        var el = document.querySelector('script.kaching-bundles-deal-block-settings');
        var d = el && JSON.parse(el.textContent || '{}');
        return !!(d && (d.dealBars || []).some(function (b) { return b.quantity >= 2 && b.discountType && b.discountType !== 'default' && Number(b.discountValue) > 0; }));
      } catch (e) { return false; }
    };
    var HS_GIFTS = "lxgifts=47025167925295%2C44740616552495%2C47044500684847%2C47042706047023&lxsale=Halloween%20Sale%3A%20%24102%20in%20FREE%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxdrop=43136402358319&lxcopy=Buy%202%20%26%20get%202%20Cosmetic%20Bags%3E%3EBuy%202%20Bags%7CFLASH%20SALE%3E%3EHALLOWEEN%20SALE%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24102%7CNational%20Girlfriends%20Day%20Sale%3E%3EHalloween%20Sale%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%204%20FREE%20Gifts%20%28%24102%20value%29&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Halloween%20Sale%29%20%F0%9F%8E%83&lxppoffer=1", HS_BOGO = "lxgifts=47025167925295%2C44740616552495%2C47044500684847%2C47042706047023&lxsale=Halloween%20Sale%3A%20BOGO%2050%25%20OFF%20%2B%20%24102%20in%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxdrop=43136402358319&lxcopy=Buy%202%20%26%20get%202%20Cosmetic%20Bags%3E%3EBuy%202%20%26%20Save%2050%25%7CFLASH%20SALE%3E%3EHALLOWEEN%20SALE%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24102%7CNational%20Girlfriends%20Day%20Sale%3E%3EHalloween%20Sale%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%204%20FREE%20Gifts%20%28%24102%20value%29&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Halloween%20Sale%29%20%F0%9F%8E%83&lxppoffer=1";
    // 28 Oct 2026 (John): the Halloween Sale page sells WITH Luhxe Protection+ by default (lxppoffer=1 in both built-ins). Gift strip off there — the Protection+ panel already shows the 4 gifts. Offer box
    // ("Gifts claimed 846/1000") removed too (28 Oct, Chris).
    var BUILTIN = { 'luhxe-travel-bag-2-0-halloween-sale': (window.lxDeal2Discounts() ? HS_BOGO : HS_GIFTS),
      'luhxe-travel-bag-2-0-halloween-bogo': "lxgifts=47025167925295,44740616552495,47044500684847,47042706047023&lxsale=Halloween%20Sale%3A%20Buy%201%20Get%201%20FREE%20%2B%204%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxoffer=Halloween%20Sale%3A%20BOGO%20%2B%7C%24102%20in%20FREE%20Gifts!&lxclaim=846%2F1000&lxgiftstrip=1&lxcopy=1%20For%20Your%20Partner%3E%3E1%20To%20Gift%7CFLASH%20SALE%3E%3EHALLOWEEN%20SALE%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24102&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Halloween%20BOGO%29%20%F0%9F%8E%83" };
    BUILTIN['luhxe-travel-bag-2-0-halloween-bogo-em'] = BUILTIN['luhxe-travel-bag-2-0-halloween-bogo'];   // 26 Oct 2026: second copy of the Buy 1 Get 1 page
    // 30 Oct 2026 (Chris): Early Black Friday page = the Halloween Sale offer exactly (BOGO 50% + 4 gifts + Protection+ 7-day
    // trial), Early Black Friday wording. Goes live 1 Nov by sending /products/luhxe and /products/luhxe-0 here (Intelligems).
    BUILTIN['luhxe-travel-bag-2-0-early-black-friday'] = window.lxDeal2Discounts()
      ? "lxgifts=47025167925295%2C44740616552495%2C47044500684847%2C47042706047023&lxsale=Early%20Black%20Friday%3A%20BOGO%2050%25%20OFF%20%2B%20%24102%20in%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxdrop=43136402358319&lxcopy=Buy%202%20%26%20get%202%20Cosmetic%20Bags%3E%3EBuy%202%20%26%20Save%2050%25%7CFLASH%20SALE%3E%3EEARLY%20BLACK%20FRIDAY%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24102%7CNational%20Girlfriends%20Day%20Sale%3E%3EEarly%20Black%20Friday%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%204%20FREE%20Gifts%20%28%24102%20value%29&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Early%20Black%20Friday%29&lxppoffer=1"
      : "lxgifts=47025167925295%2C44740616552495%2C47044500684847%2C47042706047023&lxsale=Early%20Black%20Friday%3A%20%24102%20in%20FREE%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxdrop=43136402358319&lxcopy=Buy%202%20%26%20get%202%20Cosmetic%20Bags%3E%3EBuy%202%20Bags%7CFLASH%20SALE%3E%3EEARLY%20BLACK%20FRIDAY%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24102%7CNational%20Girlfriends%20Day%20Sale%3E%3EEarly%20Black%20Friday%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%204%20FREE%20Gifts%20%28%24102%20value%29&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Early%20Black%20Friday%29&lxppoffer=1";   // 26 Oct 2026: second copy of the Buy 1 Get 1 page
    var builtinUsed = false;
    // 30 Oct 2026: Early Black Friday Buy 1 Get 1 email page = the Halloween Buy 1 Get 1 page ($179 / $279 for 1 or 2 bags,
    // 4 gifts, no Protection+), Early Black Friday wording. For the email team.
    // 30 Oct 2026 (Chris: "yes protection + on bogo email page as well"): sells WITH Luhxe Protection+ like the main Early Black
    // Friday page (lxppoffer=1); offer box and gift strip off, as on the Halloween Sale page, since the Protection+ panel shows the gifts.
    BUILTIN['luhxe-travel-bag-2-0-early-black-friday-bogo'] = "lxgifts=47025167925295%2C44740616552495%2C47044500684847%2C47042706047023&lxsale=Early%20Black%20Friday%3A%20Buy%201%20Get%201%20FREE%20%2B%204%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxppoffer=1&lxcopy=1%20For%20Your%20Partner%3E%3E1%20To%20Gift%7CFLASH%20SALE%3E%3EEARLY%20BLACK%20FRIDAY%7CLABOR%20DAY%20SALE%3E%3EEARLY%20BLACK%20FRIDAY%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24102%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%204%20FREE%20Gifts%20%28%24102%20value%29&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Early%20Black%20Friday%20BOGO%29";
    // 03 Nov 2026 (Chris): Black Friday pages (11/11) = the Early Black Friday pages with the Cosmetic Bag swapped for the Keychain
    // Tracker, the $25 e-Gift Card for a $50 one, plus the 24/7 AI Travel Concierge ($25 value, shown only) = $152. No Protection+.
    BUILTIN['luhxe-travel-bag-2-0-black-friday'] = window.lxDeal2Discounts()
      ? "lxgifts=47110174769199%2C44740616552495%2C47115101962287%2C47044500684847&lxsale=Black%20Friday%3A%20BOGO%2050%25%20OFF%20%2B%20%24152%20in%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxdrop=43136402358319&lxcopy=Buy%202%20%26%20get%202%20Cosmetic%20Bags%3E%3EBuy%202%20%26%20Save%2050%25%7CFLASH%20SALE%3E%3EBLACK%20FRIDAY%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24152%7CNational%20Girlfriends%20Day%20Sale%3E%3EBlack%20Friday%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%205%20FREE%20Gifts%20%28%24152%20value%29%7CIncludes%204%20FREE%20Gifts%20%28%24102%20value%29%3E%3EIncludes%205%20FREE%20Gifts%20%28%24152%20value%29%7C%24102%3E%3E%24152%7CEARLY%20BLACK%20FRIDAY%3E%3EBLACK%20FRIDAY%7CEarly%20Black%20Friday%3E%3EBlack%20Friday&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Black%20Friday%29&lxppoffer=1"
      : "lxgifts=47110174769199%2C44740616552495%2C47115101962287%2C47044500684847&lxsale=Black%20Friday%3A%20%24152%20in%20FREE%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxdrop=43136402358319&lxcopy=Buy%202%20%26%20get%202%20Cosmetic%20Bags%3E%3EBuy%202%20Bags%7CFLASH%20SALE%3E%3EBLACK%20FRIDAY%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24152%7CNational%20Girlfriends%20Day%20Sale%3E%3EBlack%20Friday%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%205%20FREE%20Gifts%20%28%24152%20value%29%7CIncludes%204%20FREE%20Gifts%20%28%24102%20value%29%3E%3EIncludes%205%20FREE%20Gifts%20%28%24152%20value%29%7C%24102%3E%3E%24152%7CEARLY%20BLACK%20FRIDAY%3E%3EBLACK%20FRIDAY%7CEarly%20Black%20Friday%3E%3EBlack%20Friday&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Black%20Friday%29&lxppoffer=1";
    BUILTIN['luhxe-travel-bag-2-0-black-friday-bogo'] = "lxgifts=47110174769199%2C44740616552495%2C47115101962287%2C47044500684847&lxsale=Black%20Friday%3A%20Buy%201%20Get%201%20FREE%20%2B%205%20Gifts&lxbadge=0&lxtopbar=1&lxbanner=0&lxppoffer=1&lxcopy=1%20For%20Your%20Partner%3E%3E1%20To%20Gift%7CFLASH%20SALE%3E%3EBLACK%20FRIDAY%7CLABOR%20DAY%20SALE%3E%3EBLACK%20FRIDAY%7Cfree%20gifts%20worth%20%2435%3E%3Efree%20gifts%20worth%20%24152%7CIn-Stock%3A%20Ready%20To%20Ship%3E%3EIncludes%205%20FREE%20Gifts%20%28%24152%20value%29%7CIncludes%204%20FREE%20Gifts%20%28%24102%20value%29%3E%3EIncludes%205%20FREE%20Gifts%20%28%24152%20value%29%7C%24102%3E%3E%24152%7CEARLY%20BLACK%20FRIDAY%3E%3EBLACK%20FRIDAY%7CEarly%20Black%20Friday%3E%3EBlack%20Friday&lxtitle=Luhxe%20Travel%20Bag%202.0%20%28Black%20Friday%20BOGO%29";
    (function () {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/), h = m && decodeURIComponent(m[1]);
      if (!h || !BUILTIN[h]) return;
      var own = false;
      q.forEach(function (v, k) { if (/^lx/.test(k) && ['lxpreview', 'lxhero', 'lxpp'].indexOf(k) === -1) own = true; });
      if (own) return;
      new URLSearchParams(BUILTIN[h]).forEach(function (v, k) { q.set(k, v); });
      builtinUsed = true;
    })();
    var promo = q.get('lxpromo');
    var pct = parseFloat(q.get('lxpct') || '0');
    var amt = parseFloat(q.get('lxamt') || '0');
    // Shopify's /discount/CODE?redirect=... does NOT fully decode the inner query, so a
    // value that was encoded before being wrapped arrives still escaped:
    //   lxsale    -> "Labor%20Day%20Sale"
    //   lxgiftfor -> "Rose%2CSnow"   (one token, matches no colour -> gift never applies)
    // Measured 2 Sep 2026 on the live redirect chain. Decode again when the value still
    // looks escaped, so links ALREADY sent out keep working.
    var dec = function (v) {
      v = v || '';
      try { return /%[0-9A-Fa-f]{2}/.test(v) ? decodeURIComponent(v) : v; } catch (e) { return v; }
    };
    // A gift token is "variant" or "variant:sellingPlan" (15 Oct 2026: Protection Plus is a
    // subscription; /cart/add.js refuses it -- and the whole batch -- without its plan).
    var giftPlan = {};
    var gifts = dec(q.get('lxgifts') || '').split(',').filter(Boolean).map(function (t) {
      var p = t.split(':'); if (p[1]) giftPlan[p[0]] = p[1]; return p[0];
    });
    // Find My tag colour picker (lxtagpick=1). The cart drawer hides the tag line
    // (assets/pp-cart.liquid), so the page is the only place the customer can choose.
    var TAGS_PAID = [['46191725576239', 'Rose', '#d9a6a0'], ['46191725609007', 'Snow', '#f4f1ec'], ['46191725641775', 'Black', '#1c1c1c']];
    // 20 Oct 2026: the FREE gift tag (product find-my-tag-gift, $0, SKU = the paid variant id).
    // A different handle, so the store's Protection Plus cart rule does not remove it when
    // there is no membership -- Arvin wanted the tag on its own.
    var TAGS_FREE = [['47018722525231', 'Rose', '#d9a6a0'], ['47018722557999', 'Snow', '#f4f1ec'], ['47018722590767', 'Black', '#1c1c1c']];
    var TAGS = TAGS_PAID;
    // A tag listed as a GIFT is meant to be free: links built before 20 Oct carry the paid
    // variant ($24.99), including the Halloween link already sent out. Swap it for the $0 one.
    (function () { var map = {}; TAGS_PAID.forEach(function (t, i) { map[t[0]] = TAGS_FREE[i][0]; });
      gifts = gifts.map(function (v) { return map[v] || v; }); })();
    // 21 Oct 2026: the store's Protection Plus cart layer (snippets/pp-cart.liquid, not ours) deletes the $0
    // cosmetic bag (luhxe-cosmetic-bag-1, 44740572643375) from any cart without a membership, so a link giving
    // just a free cosmetic bag lost it within seconds. Without a membership in the link, use the gift copy
    // that layer leaves alone (luhxe-cosmetic-bag-gift, $0, same warehouse SKU 42955726159919).
    var COS_OLD = '44740572643375', COS_GIFT = '47025167925295', MEMBERSHIPS = ['46176032817199', '46242945663023'];
    function cosRemap(list) {
      var member = list.some(function (v) { return MEMBERSHIPS.indexOf(String(v).split(':')[0]) !== -1; });
      return member ? list : list.map(function (v) { return String(v).split(':')[0] === COS_OLD ? COS_GIFT : v; });
    }
    gifts = cosRemap(gifts);
    // 23 Oct 2026 (Chris: "can we just make it what we labeled it on the frontend"). The Halloween page sells the guide as a $29
    // value; the real guide is $19 and also sells on its own, so this page gives a $29 gift copy of it (3-free-travelers-guides-offer-29).
    if (/\/products\/luhxe-travel-bag-2-0-(halloween-(bogo|sale)|early-black-friday|black-friday)\b/.test(location.pathname)) gifts = gifts.map(function (v) { return String(v).split(':')[0] === '43134073045039' ? '47044500684847' : v; });
    // 28 Oct 2026 (Chris): lxppoffer=1 -> the 4 free gifts come WITH Luhxe Protection+ (7-day free trial, then $24.99 every
    // 30 days; his T&C at /pages/luhxe-protection-plus-terms). Add to Cart puts in the bag, the membership and the gifts;
    // "Add to cart without $102 in free gifts" puts in the bag alone and takes the membership and gifts back out.
    // The membership is the existing 7-day trial product (luhxe-protection-plus-2, plan 2763423791, the same offer the main
    // page ran as cohort PP-T4-COSBAG-7D-2499). Every line this page adds carries its own cohort so the test is measured on
    // its own. A renamed copy of the plan can only be made in the subscription app; swap PPO.v / PPO.plan when it exists.
    // 03 Nov 2026 (Chris, Loom): Protection+ is OFF on the front end, on every page. The free gifts stay, no subscription
    // needed. lxppoffer=1 now only means "show the gift box" (heading + 4 gift tiles) under Add to Cart. PP_ON=true restores it.
    var PP_ON = false;
    var PPGIFT = /^(1|true|yes)$/i.test(dec(q.get('lxppoffer') || '').trim());
    var PPO = PP_ON && PPGIFT
      ? { v: '46993646845999', plan: '2763423791', cohort: /\/products\/luhxe-travel-bag-2-0-early-black-friday-bogo\b/.test(location.pathname) ? 'PP-T7-EBF-BOGO-7D-2499'
        : /\/products\/luhxe-travel-bag-2-0-early-black-friday\b/.test(location.pathname) ? 'PP-T6-EBF-7D-2499' : 'PP-T5-HALLOWEEN-7D-2499' } : null;
    // the sale name in the Protection+ panel heading (30 Oct 2026: Early Black Friday page)
    var PPHEAD = /\/products\/luhxe-travel-bag-2-0-black-friday\b/.test(location.pathname) ? 'Black Friday' : /\/products\/luhxe-travel-bag-2-0-early-black-friday\b/.test(location.pathname) ? 'Early Black Friday' : 'Halloween Sale';
    var PPBF = PPHEAD === 'Black Friday', PPVAL = PPBF ? '$152' : '$102';   // 03 Nov 2026: Black Friday = $152 incl. the AI Concierge
    var PPKEY = 'lxppoff:' + location.pathname;
    var ppOff = false;
    try { ppOff = !!(PPO && sessionStorage.getItem(PPKEY) === '1'); } catch (e) {}
    if (PPO) { gifts = [PPO.v].concat(gifts.filter(function (v) { return v !== PPO.v; })); giftPlan[PPO.v] = PPO.plan; }
    // 29 Oct 2026 (Arvin): lxreq = the free gifts only come WITH a paid add-on, at the add-on's own price (Luhxe Concierge,
    // Luhxe Protection Plus, or LHX Club = Protection Plus + Find My Tag). Format "Label~token+token~handle": the first token is
    // the membership ("variant:plan"), any others go in with it (the club's tag), handle = where its plan price is read.
    // Same machinery as lxppoffer: Add to Cart = bag + add-on + gifts; "Add to cart without the free gifts" = bag alone; and if
    // the customer takes the add-on out of the cart, the gifts come out too (gift lines carry _lx_req = the add-on's variant).
    var REQ = null;
    (function () {
      var raw = dec(q.get('lxreq') || ''); if (!PP_ON || !raw || PPO) return;
      var parts = raw.split('~'); if (parts.length < 2) return;
      var toks = parts[1].split('+').map(function (t) { return t.trim(); }).filter(Boolean);
      var m = (toks[0] || '').split(':'); if (!/^\d+$/.test(m[0] || '') || !/^\d+$/.test(m[1] || '')) return;
      REQ = { v: m[0], plan: m[1], label: (parts[0] || '').trim() || 'the add-on', handle: (parts[2] || '').trim(), toks: toks, price: '' };
    })();
    if (REQ) {
      var reqVs = REQ.toks.map(function (t) { var p = t.split(':'); if (p[1]) giftPlan[p[0]] = p[1]; return p[0]; });
      gifts = reqVs.concat(gifts.filter(function (v) { return reqVs.indexOf(v) === -1; }));
      REQ.extra = reqVs.slice(1);
    }
    var OFFER = PPO || REQ;
    if (REQ && !PPO) { try { ppOff = sessionStorage.getItem(PPKEY) === '1'; } catch (e) {} }
    function giftProps(v) {
      if (REQ) {
        if (String(v) === REQ.v || REQ.extra.indexOf(String(v)) !== -1) return null;
        return { 'Included with': REQ.label, '_lx_req': REQ.v };
      }
      // 03 Nov 2026: gifts now cost money without a bag (checkout discount needs a bag), so every gift this script adds carries a
      // hidden _lxgift marker: if the bag leaves the cart, orphanLines() takes these out whatever their price.
      if (!PPO) return { '_lxgift': '1' };
      if (String(v) === PPO.v) return { 'First 7 days free': 'then $24.99 every 30 days. Cancel anytime.', '_protection_plus_cohort': PPO.cohort };
      return { 'Included with': 'Luhxe Protection+', '_protection_plus_cohort': PPO.cohort };
    }
    var tagPick = /^(1|true|yes)$/i.test(dec(q.get('lxtagpick') || '').trim());
    // lxchoose = the customer picks ONE gift (Arvin, 20 Oct). Options separated by "|", each
    // "Label~token+token" (a token is "variant" or "variant:plan"). Example:
    //   lxchoose=$25 Gift Card~47015322058799|Find My Tag~47018722590767
    var chooseOpts = dec(q.get('lxchoose') || '').split('|').map(function (o) {
      var i = o.indexOf('~'); var label = i >= 0 ? o.slice(0, i).trim() : ''; var toks = (i >= 0 ? o.slice(i + 1) : o).split('+').map(function (t) { return t.trim(); }).filter(Boolean);
      return toks.length ? { label: label || 'Gift', toks: toks } : null;
    }).filter(Boolean);
    var choice = 0;
    try { var sc = parseInt(sessionStorage.getItem('lxchoice') || '0', 10); if (sc >= 0 && sc < chooseOpts.length) choice = sc; } catch (e) {}
    function optVariants(o) { return cosRemap(gifts.concat(o.toks)).slice(gifts.length).map(function (t) { var p = String(t).split(':'); if (p[1]) giftPlan[p[0]] = p[1]; return p[0]; }); }
    var baseGifts = gifts.slice();
    if (chooseOpts.length) optVariants(chooseOpts[choice]).forEach(function (v) { if (gifts.indexOf(v) === -1) gifts.push(v); });
    function inSet(set, v) { for (var i = 0; i < set.length; i++) { if (set[i][0] === String(v)) return true; } return false; }
    // whichever tag set the link uses drives the colour picker
    for (var gi = 0; gi < gifts.length; gi++) { if (inSet(TAGS_FREE, gifts[gi])) { TAGS = TAGS_FREE; break; } }
    function isTag(v) { return inSet(TAGS_PAID, v) || inSet(TAGS_FREE, v); }
    function curTag() { for (var i = 0; i < gifts.length; i++) { if (isTag(gifts[i])) return gifts[i]; } return null; }
    if (tagPick && curTag()) {
      try {
        var savedTag = sessionStorage.getItem('lxtag');
        if (savedTag && inSet(TAGS, savedTag) && curTag()) gifts[gifts.indexOf(curTag())] = savedTag;
      } catch (e) {}
    }
    var sale = dec(q.get('lxsale') || '').trim();
    var badgeOn = !/^(0|false|no|off)$/i.test(dec(q.get('lxbadge') || '').trim());
    var giftStrip = /^(1|true|yes)$/i.test(dec(q.get('lxgiftstrip') || '').trim());
    var topOnly = /^(1|true|yes|sale|static)$/i.test(dec(q.get('lxtopbar') || '').trim());
    var hideLow = /^(0|false|no|off|hide)$/i.test(dec(q.get('lxlowstock') || '').trim());
    var bannerOn = !/^(0|false|no|off|hide)$/i.test(dec(q.get('lxbanner') || '').trim());
    var offerParts = dec(q.get('lxoffer') || '').split('|').map(function (x) { return x.trim(); });
    var offerTitle = offerParts[0] || '', offerAccent = offerParts.slice(1).join(' ').trim();
    var claimM = dec(q.get('lxclaim') || '').trim().match(/^(\d+)\s*\/\s*(\d+)$/);
    if (offerTitle || offerAccent) hideLow = true;   // "that code thing can replace that warning low stock remaining thing"
    var giftFor = dec(q.get('lxgiftfor') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    // lxgiftper=1 -> ONE gift PER qualifying bag in the cart, not one per order.
    // Opt-in on purpose: links already sent out keep the old one-gift behaviour.
    var giftPer = /^(1|true|bag|match|yes)$/i.test(dec(q.get('lxgiftper') || '').trim());
    var GIFT_CAP = 10;   // a $0 line is still a real item to pick and pack
    // lxcopy = "Shoe Bag>>Cosmetic Bag|20 Value>>29 Value"
    // A design carries its own baked copy. The master's bundle tiers say "1x Luhxe Bag +
    // Free Shoe Bag ($20 Value)", so a cosmetic-bag campaign run on that design
    // contradicts itself on the page -- Brian, 2 Sep: "it says free shoebag when we're
    // not giving a free shoebag". No URL param can edit a GemPages design, but the page
    // text can be corrected in place, on campaign links only.
    // lxdrop = comma variant ids to KEEP OUT of the cart on this link. The store has an
    // app that auto-adds a $19 Traveler's Guide the customer never chose, which shows up
    // in a campaign cart as an unexplained charge next to a "free gift". A campaign link
    // can now say what does NOT belong in it.
    var drops = dec(q.get('lxdrop') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var copyRules = dec(q.get('lxcopy') || '').split('|').map(function (p) {
      var i = p.indexOf('>>'); if (i < 0) return null;
      var from = p.slice(0, i).trim(), to = p.slice(i + 2).trim();
      return from ? { from: from, to: to } : null;
    }).filter(Boolean);
    var names = []; // filled from the cart after gifts are added (no fragile name param in the URL)
    // lxtitle = the product title shown on the page (Arvin, 21 Oct: a design can show another
    // product's name, e.g. "Luhxe Travel Bag 2.0 (Fall Sale)").
    var pageTitle = dec(q.get('lxtitle') || '').trim();
    // lxbogo=1 -> Buy 1 Get 1 Free (Arvin, 21 Oct 2026: "Halloween Sale: Buy 1 Get 1 + Free Cosmetic").
    // The PRICE is the code in lxpromo (HALLOWEENBOGO: 50% off each bag when 2+ are in the cart). Measured
    // 21 Oct on /products/luhxe: the code replaces the page's own Buy 2 deal in the cart AND at checkout
    // (2 Classic $129, 2 Roller $179, Classic + Roller $154, 1 bag full price). This flag only makes the
    // page SAY it, so the bar, the buy buttons, the sticky bar and the cart all show one number.
    var bogo = /^(1|true|yes)$/i.test(dec(q.get('lxbogo') || '').trim()) && !!promo;
    if (!promo && !gifts.length && !sale && !copyRules.length && !drops.length && !pageTitle && !hideLow && bannerOn) return; // normal traffic: do nothing

    // ---- sale window -------------------------------------------------------
    var parseWhen = function (v) { if (!v) return null; var d = new Date(v); return isNaN(d.getTime()) ? null : d; };
    var startsAt = parseWhen(dec(q.get('lxfrom')));
    var endsAt   = parseWhen(dec(q.get('lxuntil')));
    var now = new Date();
    var notYet = !!(startsAt && now < startsAt);
    var isOver = !!(endsAt && now > endsAt);
    // lxpreview=1 (20 Oct 2026, Arvin): a scheduled link does nothing before its start, so
    // testing it today looked broken. The builder's "Open & test" adds this flag so the team
    // sees the live behaviour now. Customers never get it: the copied link has no flag.
    var preview = /^(1|true|yes)$/i.test(dec(q.get('lxpreview') || '').trim()) && notYet;
    if (preview) notYet = false;
    // A sale that has ended must stop behaving like a sale. Silently running a finished
    // campaign is how a store keeps giving away product after the offer is over.
    if (isOver || notYet) {
      try {
        var over = document.createElement('div');
        over.id = 'lx-ended';
        over.style.cssText = 'margin:16px 0;padding:12px 14px;border-radius:8px;background:#f6f4ef;border:1px solid rgba(18,18,18,.12);font:600 13.5px/1.45 inherit;color:#6b6b6b';
        over.textContent = notYet
          ? ((sale || 'This sale') + ' starts ' + startsAt.toLocaleString())
          : ((sale || 'This sale') + ' has ended.');
        var mount = function () { var a = buyAnchor(); if (a && a.parentNode) a.parentNode.insertBefore(over, a); };
        if (document.readyState !== 'loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
      } catch (e) {}
      return; // no gift, no code banner, no price line
    }
    window.__lxGiftsActive = gifts.length > 0;

    var esc = function (t) { var d = document.createElement('div'); d.textContent = String(t == null ? '' : t); return d.innerHTML; };
    // currency-correct money from cents (customer's active currency, any locale)
    var money = function (c) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(c / 100); }
      catch (e) { return '$' + (c / 100).toFixed(2); }
    };
    // the MAIN product (its variants only) from Shopify's own JSON — prices in cents, active currency
    var PROD = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || null;
    // THE DEFAULT OFFER (21 Oct 2026): product 8322360999983, /products/luhxe-travel-bag-2-0-special-offer
    // (was the unused July 4th clone). Its own deal is Buy 1 / Buy 2 at normal price -- measured: two bags
    // ring $258 at checkout -- unlike /products/luhxe, whose bundle app takes 50% off any two bags whatever
    // the link says. EasyGift still has its old July rule on it (adds a Guide, a Shoe Bag and a Cosmetic
    // Bag), so on campaign links those are blocked: the link's own gifts are the offer.
    var DEFAULT_OFFER_PID = '8322360999983';
    var isDefaultOffer = !!(PROD && String(PROD.id) === DEFAULT_OFFER_PID);
    var EG_JULY = ['43134073045039', '42128545251375', '43136402358319'];
    if (isDefaultOffer) EG_JULY.forEach(function (v) { if (drops.indexOf(v) === -1 && gifts.indexOf(v) === -1) drops.push(v); });
    function mainVariantPriceCents() {
      if (!PROD || !PROD.variants || !PROD.variants.length) return 0;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = v; });
      var chosen = null;
      var uv = new URLSearchParams(location.search).get('variant');
      if (uv && ids[uv]) chosen = ids[uv];
      if (!chosen) { var inp = document.querySelectorAll('[name="id"]'); for (var i = 0; i < inp.length; i++) { if (ids[String(inp[i].value)]) { chosen = ids[String(inp[i].value)]; break; } } }
      if (!chosen) chosen = PROD.variants[0];
      return chosen.price || 0; // cents, active currency
    }

    // which variant is selected right now, and does the gift apply to it?
    function currentVariant() {
      if (!PROD || !PROD.variants || !PROD.variants.length) return null;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = v; });
      var uv = q.get('variant');
      var sel = new URLSearchParams(location.search).get('variant');
      if (sel && ids[sel]) return ids[sel];
      var inp = document.querySelectorAll('[name="id"]');
      for (var i = 0; i < inp.length; i++) { if (ids[String(inp[i].value)]) return ids[String(inp[i].value)]; }
      return PROD.variants[0];
    }
    // "Rose / Classic" -> ["rose","classic"]
    function variantValues(v) {
      if (!v) return [];
      var t = v.public_title || v.name || '';
      return String(t).split('/').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    }
    // "Rose,Snow" -> "Rose or Snow", in the casing the campaign supplied
    var giftForRaw = dec(q.get('lxgiftfor') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    function giftForLabel() {
      if (giftForRaw.length < 2) return giftForRaw.join('');
      return giftForRaw.slice(0, -1).join(', ') + ' or ' + giftForRaw[giftForRaw.length - 1];
    }
    function giftApplies() {
      if (OFFER && ppOff) return false;                 // "Add to cart without the free gifts"
      if (!giftFor.length) return true;                 // no restriction -> always
      var vals = variantValues(currentVariant());
      for (var i = 0; i < vals.length; i++) { if (giftFor.indexOf(vals[i]) !== -1) return true; }
      return false;
    }

    // How many CAMPAIGN bags are in the cart right now, counting only the variants
    // the gift actually applies to. This is read from the CART, never from the picker,
    // because the customer can put two different colourways in one cart.
    function eligibleBagUnits(cart) {
      if (!PROD || !PROD.variants) return 0;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = v; });
      var n = 0;
      (cart.items || []).forEach(function (it) {
        var vid = String(it.variant_id || it.id);
        if (gifts.indexOf(vid) !== -1) return;      // never count a gift line as a bag
        var v = ids[vid];
        if (!v) return;                             // a different product entirely
        if (giftFor.length) {
          var vals = variantValues(v), ok = false;
          for (var i = 0; i < vals.length; i++) { if (giftFor.indexOf(vals[i]) !== -1) ok = true; }
          if (!ok) return;
        }
        n += (it.quantity || 0);
      });
      return n;
    }

    // ---- cart write discipline (2 Sep 2026, Brian) -------------------------
    // Brian: "when you try removing the upsell it says this bug" -> "There was an error
    // while updating your cart." Cause: this script was calling /cart/change.js on a
    // 2.5s timer, so when he clicked the trash icon HIS theme and THIS script wrote to
    // the cart in the same moment. Shopify rejects the concurrent write and the theme
    // surfaces that error. Two rules now:
    //   1. every cart write we make goes through ONE promise chain, never in parallel,
    //   2. we back off completely for 4s after ANY cart write we did not make.
    // And we never fight the customer: if they remove one of our gifts, it stays out.
    var CQ = Promise.resolve();                 // our single write queue
    var lastForeignWrite = 0;                   // when the theme/app last wrote
    function quiet() { return Date.now() - lastForeignWrite > 1200; }
    // The bundling app writes to the cart constantly, so a long skip window meant
    // dropUnwanted() backed off forever and the $19 Guide was never removed. The write
    // QUEUE is what stops the "error while updating your cart" race; this is only a
    // short courtesy pause, and anything skipped is retried rather than abandoned.
    function cartWrite(url, body) {
      CQ = CQ.then(function () {
        return fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'lx=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin', body: JSON.stringify(body), __lx: true }).catch(function () {});
      }).then(refreshCartUI);
      return CQ;
    }

    // ⭐ THE ONE THAT CAUSED BRIAN'S "error while updating your cart".
    // This script changes the cart with raw fetch calls, which the THEME never sees, so
    // its server-rendered cart drawer keeps showing the old line list. The drawer's
    // remove buttons are LINE-INDEX based, so a stale/phantom row desynchronises every
    // control below it and Shopify answers "line parameter is invalid".
    // Fix: after any cart write WE make, re-render the theme's own cart sections through
    // Shopify's Section Rendering API, so the drawer is never stale relative to a cart we
    // changed. Verified available on this theme: /?sections=cart-drawer,cart-icon-bubble.
    var SECTIONS = 'cart-drawer,cart-icon-bubble,cart-live-region-text';
    function refreshCartUI() {
      return fetch('/?sections=' + SECTIONS, { credentials: 'same-origin', __lx: true })
        .then(function (r) { return r.json(); })
        .then(function (secs) { window.lxSwapSections(secs); })
        .catch(function () {});
    }
    // EARLY BLACK FRIDAY BAG FIRST AT CHECKOUT (30 Oct 2026, Chris: "on checkout same thing, are we able to have the bag be the first
    // thing on the top"). Checkout lists the cart newest line first, and the bag goes in before the membership and the gifts, so it
    // sat at the bottom. Once the gifts are in, each bag line is put in again as a new line (its own properties, so the bundle app's
    // deal stays on it, plus a hidden _lxtop marker so it does not merge into the old line) and the old line is taken out. The bag
    // never leaves the cart, so the Protection+ cart layer keeps the membership. Measured: same lines, same $179, bag on top.
    // Guarded (once in 7 test runs the cart came back empty after another app wrote at the same moment): the old lines only come
    // out once the cart shows the new ones, and if the cart then holds fewer bags than before, the old lines are put back.
    // Once per page view; anything unexpected leaves the cart as it was (bag at the bottom, nothing lost).
    // 30 Oct 2026 (Chris, on the live Halloween Sale page: "the bag should be on the top"): the Halloween pages too.
    var BAG_FIRST = /\/products\/luhxe-travel-bag-2-0-(early-black-friday(-bogo)?|black-friday(-bogo)?|halloween-(sale|bogo(-em)?))\/?$/.test(location.pathname);
    var BAG_HANDLE = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
    var bagMoved = false;
    function moveBagFirst() {
      if (!BAG_FIRST || bagMoved) return Promise.resolve();
      function post(u, body) {
        return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body), __lx: true });
      }
      function readCart() { return fetch('/cart.js', { credentials: 'same-origin', __lx: true }).then(function (r) { return r.json(); }); }
      function bagUnits(c) { var n = 0; (c.items || []).forEach(function (it) { if (it.handle === BAG_HANDLE) n += it.quantity || 0; }); return n; }
      function line(b, p) {
        var l = { id: b.variant_id, quantity: b.quantity, properties: p };
        if (b.selling_plan_allocation && b.selling_plan_allocation.selling_plan) l.selling_plan = b.selling_plan_allocation.selling_plan.id;
        return l;
      }
      CQ = CQ.then(function () {
        return readCart().then(function (cart) {
          var items = cart.items || [], bags = items.filter(function (it) { return it.handle === BAG_HANDLE; });
          if (!bags.length) return;
          var top = true;
          for (var i = 0; i < bags.length; i++) if (items[i].handle !== BAG_HANDLE) { top = false; break; }
          if (top) return;
          bagMoved = true;
          var units = bagUnits(cart), oldKeys = bags.map(function (b) { return b.key; });
          var add = bags.slice().reverse().map(function (b) {
            var p = {}, k; for (k in (b.properties || {})) p[k] = b.properties[k];
            p._lxtop = p._lxtop === '1' ? '2' : '1';
            return line(b, p);
          });
          return post('/cart/add.js?lx=1', { items: add }).then(function (r) {
            if (!r.ok) return;   // the new lines did not go in: keep the old ones
            return readCart().then(function (c1) {
              // the new lines must be in the cart, as lines of their own, holding every bag the old lines held
              var fresh = 0;
              (c1.items || []).forEach(function (it) { if (it.handle === BAG_HANDLE && oldKeys.indexOf(it.key) === -1 && it.properties && it.properties._lxtop) fresh += it.quantity || 0; });
              if (fresh < units) return;
              var upd = {}; oldKeys.forEach(function (k) { upd[k] = 0; });
              return post('/cart/update.js?lx=1', { updates: upd, sections: SECTIONS }).then(function (r2) { return r2.json(); }).then(function (j) {
                if (!j || bagUnits(j) < units) {
                  // fewer bags than before: put the old lines back exactly as they were
                  return post('/cart/add.js?lx=1', { items: bags.map(function (b) { return line(b, b.properties || {}); }) }).then(refreshCartUI);
                }
                if (j.sections && j.sections['cart-drawer']) window.lxSwapSections(j.sections); else return refreshCartUI();
              });
            });
          });
        }).catch(function () {});
      });
      return CQ;
    }
    // Watch the page's OWN cart writes so we can stand back, and learn what the customer
    // deliberately removed.
    // Deliberate removals are remembered for THIS page view only, deliberately not
    // persisted. Brian: "it worked once but when you retry after deleting it stops
    // working" -- so re-opening the campaign link must restore the offer, while removing
    // the gift mid-visit must not have it shoved back in.
    var REMOVED = [];
    var fastUntil = 0;          // a few seconds after a bag goes in: add the gifts without the quiet pause
    function fast() { return Date.now() < fastUntil; }
    try {
      if (window.PerformanceObserver) {
        var pfT = null;
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) {
            var nm = String(e.name || '');
            if (!/\/cart\/(add|change|update|clear)/.test(nm) || /[?&]lx=1/.test(nm)) return;
            lastForeignWrite = Date.now();
            if (/\/cart\/add/.test(nm)) fastUntil = Date.now() + 4000;
            // Right after Add to Cart the page is busy with the other apps and a 0 ms timer waited ~1.8 s (measured), so
            // the bag's arrival calls straight through; anything else waits a moment.
            if (gifts.length) { clearTimeout(pfT); if (/\/cart\/add/.test(nm)) refreshCartState(); else pfT = setTimeout(refreshCartState, 250); }
          });
        }).observe({ type: 'resource', buffered: false });
      }
    } catch (e) {}
    // 23 Oct 2026 (Chris: "the gifts dont show up on order 1"). The page's own Add to Cart comes through the fetch wrapper
    // below. Measured: the drawer opened with the bag alone and the gifts followed 1.5s later on a desktop and 6-9s later at
    // phone speed, so the first look at the cart had no gifts. A bag add now waits for the gifts too (at most 5s), so the
    // drawer opens with everything in it.
    function bagAdd(u, init) {
      if (!/\/cart\/add/.test(u) || (init && init.__lx) || !gifts.length || !giftApplies()) return false;
      var b = init && init.body, s = '';
      if (typeof b === 'string') s = b;
      else if (b && typeof FormData !== 'undefined' && b instanceof FormData) b.forEach(function (v, k) { s += k + '=' + v + '&'; });
      else if (b && typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) s = b.toString();
      if (!s) return false;
      try { kcFromBody(s); } catch (e) {}
      if (PROD && PROD.variants && PROD.variants.some(function (v) { return s.indexOf(String(v.id)) !== -1; })) return true;
      return /__kaching_bundles/.test(s);
    }
    // The bag has just gone in, so the gifts are checked against the last cart this script read (no extra read before the
    // drawer opens). The drawer is redrawn before the page carries on either way, so it opens on the real cart.
    var lastCart = null;
    function giftsWithBag() {
      if (syncing) return Promise.resolve();
      syncing = true;
      var known = lastCart ? Promise.resolve(lastCart) : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var work = known.then(function (cart) {
        var removed = userRemoved(), have = giftQty(cart), want = giftWant(cart), toAdd = [];
        gifts.forEach(function (v) {
          if (removed.indexOf(String(v)) !== -1) return;
          var cur = have[String(v)] || 0;
          if (cur < want) { var line = { id: Number(v), quantity: want - cur }; if (giftPlan[v]) line.selling_plan = Number(giftPlan[v]); var gp = giftProps(v); if (gp) line.properties = gp; toAdd.push(line); }
        });
        if (!toAdd.length) return refreshCartUI();
        autoAdds++;
        // one request: the gifts go in and the cart drawer comes back drawn with them (no second fetch before it opens)
        CQ = CQ.then(function () {
          return fetch('/cart/add.js?lx=1', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
            body: JSON.stringify({ items: toAdd, sections: SECTIONS }), __lx: true })
            .then(function (r) { return r.json(); })
            .then(function (j) { if (j && j.sections && j.sections['cart-drawer']) window.lxSwapSections(j.sections); else return refreshCartUI(); })
            .catch(function () { return refreshCartUI(); });
        });
        return moveBagFirst().then(function () { try { document.dispatchEvent(new CustomEvent('lx:gifts-added')); } catch (e) {} });
      }).catch(function () {}).then(function () { syncing = false; refreshCartState(); });
      return Promise.race([work, new Promise(function (r) { setTimeout(r, 5000); })]);
    }
    function userRemoved() { return REMOVED; }
    function noteRemoved(v) { if (REMOVED.indexOf(String(v)) === -1) REMOVED.push(String(v)); }
    (function watchCart() {
      var of = window.fetch;
      window.fetch = function (input, init) {
        try {
          var u = String((input && input.url) || input || '');
          // default offer: EasyGift's leftover July auto-gifts never go in (see DEFAULT_OFFER_PID)
          if (isDefaultOffer && /\/cart\/add/.test(u) && /_easygift_internal/.test(u)) {
            return Promise.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
          }
          if (/\/cart\/(change|update|add|clear)/.test(u) && !(init && init.__lx)) {
            lastForeignWrite = Date.now();
            try { document.dispatchEvent(new CustomEvent('lx:foreign-cart-write')); } catch (e) {}
            setTimeout(function () { if (gifts.length) refreshCartState(); checkBogoCode(); }, 900);
            // did the customer zero one of OUR gifts?
            var b = init && init.body;
            if (typeof b === 'string' && /"quantity"\s*:\s*0/.test(b)) {
              gifts.forEach(function (g) { if (b.indexOf(g) !== -1) noteRemoved(g); });
            }
          }
        } catch (e) {}
        var hold = false;
        try { hold = bagAdd(String((input && input.url) || input || ''), init); } catch (e) {}
        if (hold) {
          return of.apply(this, arguments).then(function (resp) {
            if (!resp || !resp.ok) return resp;
            return giftsWithBag().then(function () { return resp; }, function () { return resp; });
          });
        }
        return of.apply(this, arguments);
      };
    })();

    // 1) make sure the discount is really on the session (cookie) at checkout
    if (promo) { try { fetch('/discount/' + encodeURIComponent(promo), { credentials: 'same-origin' }).catch(function () {}); } catch (e) {} }

    // 2) add the free gifts to the cart once (skip any already in cart), then read their names from the cart
    var giftsInCart = false;   // what the CART says, never what we hoped
    var paidNames = [];
    // 19 Oct 2026 (Arvin: "all the freebies are not showing up at checkout"). The store's
    // Protection Plus cart layer (snippets/pp-cart.liquid, not ours) removes a membership
    // when no travel bag is in the cart, and a Find My tag / cosmetic bag when no membership
    // is. This script used to add the gifts on page load, BEFORE the bag, so they were
    // stripped within seconds and nothing put them back after Add to Cart. Gifts now go in
    // WITH the bag: none are added while the cart holds no bag, and they are (re)added as
    // soon as one appears. This also stops a free gift being checked out on its own.
    var bagInCart = null;      // null = not read yet
    var autoAdds = 0, AUTO_ADD_CAP = 6;
    function hasBag(cart) {
      if (eligibleBagUnits(cart) > 0) return true;
      if (giftFor.length) return false;          // colour-gated: only the page's own variants count
      var cfg = (window.LXPPCart && window.LXPPCart.config) || {};
      var hp = cfg.bagHandlePattern || /^luhxe(-0)?$|^luhxe-travel-bag|^luhxe-offer/i;
      var tp = cfg.bagTitlePattern || /travel bag/i;
      return (cart.items || []).some(function (it) {
        if (gifts.indexOf(String(it.variant_id || it.id)) !== -1) return false;
        return hp.test(it.handle || '') || tp.test(it.product_title || it.title || '');
      });
    }
    function missingGifts(cart) {
      var have = {}; (cart.items || []).forEach(function (it) { have[String(it.variant_id || it.id)] = true; });
      var removed = userRemoved();
      return gifts.filter(function (v) { return !have[v] && removed.indexOf(String(v)) === -1; });
    }
    // 21 Oct 2026 (Arvin: "it shows 2 cosmetic for the bogo"): one free gift per ORDER unless lxgiftper.
    // A second copy can arrive from a second open tab racing the first, or from the drawer's "+" button, and
    // the old check only ever looked for a MISSING gift, so the extra stayed. Count every line of the gift.
    function giftWant(cart) { if (!giftPer) return 1; var u = eligibleBagUnits(cart); return u > 0 ? Math.min(u, GIFT_CAP) : 1; }
    function giftQty(cart) {
      var q = {}; (cart.items || []).forEach(function (it) { var k = String(it.variant_id || it.id); q[k] = (q[k] || 0) + (it.quantity || 0); });
      return q;
    }
    function extraGifts(cart) {
      var want = giftWant(cart), q = giftQty(cart);
      return gifts.filter(function (v) { return (q[String(v)] || 0) > want; });
    }
    // Arvin, 21 Oct: "2 gift card included as free" on the Buy 1 Get 1 link. The cart still held the $25 Gift Cards
    // another campaign link had added, and nothing took them out. A link's gifts ARE its offer, so a page on a
    // campaign link takes out $0 lines of the builder's dedicated giveaway items that are not in THIS link.
    // Never a membership (Protection Plus / Concierge), never a paid line, never a line a gift or bundle app
    // marked as its own.
    var KNOWN_GIFTS = ['45523752484911', '47015322058799', '43435014946863', '44740572643375', '47025167925295',
      '43453912023087', '44740616552495', '43134073045039', '43423814713391', '43671595483183', '44703600607279',
      '44606216765487', '42341584338991', '47018722525231', '47018722557999', '47018722590767', '47042706047023', '47044500684847'];
    // 03 Nov 2026 (client): the free Keychain Tracker follows the BAG colour - Rose bag -> Pink, Charcoal -> Black, Snow -> White.
    // Picked from the bag being added (Kaching's request body), then kept in line with the first campaign bag in the cart; the
    // gift tile on the page follows the bundle box's selected colour. A keychain of the wrong colour is a "foreign" $0 gift
    // line, so the normal sync swaps it.
    var KC = { rose: '47110174801967', charcoal: '47110174769199', snow: '47110174834735' };
    var KC_IDS = [KC.rose, KC.charcoal, KC.snow];
    var KC_IMG = {};
    KC_IMG[KC.rose] = 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-keychain-tracker-pink.png?v=1793732772'; KC_IMG[KC.charcoal] = 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-keychain-tracker.png?v=1793724722'; KC_IMG[KC.snow] = 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-keychain-tracker-white.png?v=1793732777';
    KC_IDS.forEach(function (v) { if (KNOWN_GIFTS.indexOf(v) === -1) KNOWN_GIFTS.push(v); });
    function kcCur() { for (var i = 0; i < gifts.length; i++) { if (KC_IDS.indexOf(String(gifts[i])) !== -1) return String(gifts[i]); } return null; }
    function kcPaint() {
      var cur = kcCur(); if (!cur || !KC_IMG[cur]) return;
      var im = document.querySelector('#lx-pp img[alt="Free Keychain Tracker"]');
      if (im && im.getAttribute('src').indexOf(KC_IMG[cur].split('?')[0]) === -1) im.setAttribute('src', KC_IMG[cur] + '&width=300');
    }
    function kcSet(colour) {
      var want = KC[String(colour || '').toLowerCase()], cur = kcCur();
      if (!want || !cur || cur === want) return;
      gifts[gifts.indexOf(cur)] = want;
      kcPaint();
    }
    function kcVariant(id) {
      if (!PROD || !PROD.variants) return null;
      for (var i = 0; i < PROD.variants.length; i++) { if (String(PROD.variants[i].id) === String(id)) return PROD.variants[i]; }
      return null;
    }
    function kcFromBody(s) {
      if (!kcCur() || !PROD || !PROD.variants) return;
      var best = -1, col = null;
      PROD.variants.forEach(function (v) { var i = s.indexOf(String(v.id)); if (i !== -1 && (best === -1 || i < best)) { best = i; col = variantValues(v)[0]; } });
      if (col) kcSet(col);
    }
    function kcFromCart(cart) {
      if (!kcCur()) return;
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) { var v = kcVariant(items[i].variant_id || items[i].id); if (v) { kcSet(variantValues(v)[0]); return; } }
    }
    function kcFromBundle() {
      if (!kcCur()) return;
      var inp = document.querySelector('kaching-bundles-block input[type=radio]:checked');
      var bar = inp && (inp.closest('label') || inp.parentNode);
      var m = bar && String(bar.innerText || '').match(/\b(Rose|Charcoal|Snow)\b/i);
      if (m) kcSet(m[1]);
    }
    if (kcCur()) {
      var kcN = 0, kcT = setInterval(function () { kcFromBundle(); kcPaint(); if (++kcN > 400) clearInterval(kcT); }, 700);
      document.addEventListener('change', function () { setTimeout(kcFromBundle, 250); }, true);
      document.addEventListener('click', function () { setTimeout(kcFromBundle, 400); }, true);
    }
    // 03 Nov 2026: ad links carry ?variant=<colour/model> (snippets/lx-style-fixes maps main-page ids to this page's). The bundle box
    // ignored it and always started on Rose / Classic, so a Charcoal ad added Rose bags. Once the box is drawn, point it at the linked
    // variant: Kaching's own variant attribute re-draws every bar and item in that colour/model. Once per page view.
    (function () {
      var vq = new URLSearchParams(location.search).get('variant'), v = vq && kcVariant(vq);
      if (!v) return;
      // The store's kaching-debug.js resets the box to the first variant ~3s in, racing this: keep the linked variant for 10s after
      // the box is drawn, and stop the moment the shopper touches the box themselves.
      var touched = false, drawnAt = 0, n = 0;
      document.addEventListener('pointerdown', function (e) { if (e.target && e.target.closest && e.target.closest('kaching-bundles-block')) touched = true; }, true);
      var t = setInterval(function () {
        var blk = document.querySelector('kaching-bundles-block');
        if (++n > 120 || touched) { clearInterval(t); return; }
        if (!blk || !blk.querySelector('input[type=radio]')) return;
        if (!drawnAt) drawnAt = n;
        if (String(blk.getAttribute('current-variant-id')) !== String(v.id)) { blk.setAttribute('current-variant-id', String(v.id)); setTimeout(function () { kcSet(variantValues(v)[0]); kcPaint(); }, 400); }
        if (n - drawnAt > 40) clearInterval(t);
      }, 250);
    })();
    function foreignGiftLines(cart) {
      return (cart.items || []).filter(function (it) {
        var vid = String(it.variant_id || it.id);
        if (gifts.indexOf(vid) !== -1 || KNOWN_GIFTS.indexOf(vid) === -1) return false;
        if ((it.final_line_price || 0) !== 0) return false;
        return !/easygift|_eg_|kaching/i.test(Object.keys(it.properties || {}).join(' '));
      });
    }
    // 23 Oct 2026 (Chris): "if I remove the bag the free gifts are still there, so that should go away". Gifts go in with
    // the bag and now come out with it: free lines of this link or of the dedicated giveaways, and any link-priced copy
    // (product type "LX gift copy"). Never a tag (the store's Protection Plus layer owns those), never a membership or an
    // add-on at its normal price.
    var TAG_IDS = TAGS_PAID.concat(TAGS_FREE).map(function (t) { return t[0]; });
    function orphanLines(cart) {
      return (cart.items || []).filter(function (it) {
        var vid = String(it.variant_id || it.id);
        if (TAG_IDS.indexOf(vid) !== -1) return false;
        if (it.product_type === 'LX gift copy') return true;
        if (it.properties && it.properties._lxgift) return true;   // 03 Nov 2026: added by this script as a gift
        if ((it.final_line_price || 0) !== 0) return false;
        return gifts.indexOf(vid) !== -1 || KNOWN_GIFTS.indexOf(vid) !== -1;
      });
    }
    var trims = 0, TRIM_CAP = 12;
    var cartRead = false;      // have we successfully READ the cart even once?
    var reqSeen = false, reqMiss = 0;
    function namesFromCart(cart) {
      lastCart = cart;
      var byId = {}; (cart.items || []).forEach(function (it) { byId[String(it.variant_id || it.id)] = (it.product_title || it.title || '').split(' - ')[0]; });
      // A gift line the cart CHARGES for is not called free (19 Oct: the Find My tag rings
      // $24.99 unless EasyGift adds it itself). Name it separately, with its price.
      var paidBy = {}; (cart.items || []).forEach(function (it) { if ((it.final_line_price || 0) > 0) paidBy[String(it.variant_id || it.id)] = it.final_line_price; });
      var inCart = gifts.filter(function (v) { return byId[v]; });
      names = inCart.filter(function (v) { return !paidBy[v]; }).map(function (v) { return byId[v]; });
      paidNames = inCart.filter(function (v) { return paidBy[v]; }).map(function (v) { return byId[v] + ' (' + money(paidBy[v]) + ')'; });
      giftsInCart = inCart.length > 0;
      cartRead = true;
      bagInCart = hasBag(cart);
      if (REQ && !ppOff) {
        var reqIn = (cart.items || []).some(function (it) { return String(it.variant_id || it.id) === REQ.v; });
        if (reqIn) { reqSeen = true; reqMiss = 0; }
        else if (bagInCart && !syncing) {
          // they took the add-on out (or it could not go in): the gifts are conditional on it, so they come out too
          if (reqSeen || ++reqMiss >= 3) { reqSeen = false; reqMiss = 0; setPpOff(true); setTimeout(syncGifts, 300); }
        }
      }
      if (bagInCart && giftApplies() && !syncing && autoAdds < AUTO_ADD_CAP && missingGifts(cart).length) {
        autoAdds++; if (fast()) syncGifts(); else setTimeout(syncGifts, 400);
      } else if (giftApplies() && !syncing && trims < TRIM_CAP && (extraGifts(cart).length || (bagInCart && foreignGiftLines(cart).length))) {
        trims++; setTimeout(syncGifts, 400);
      } else if (!bagInCart && giftApplies() && !syncing && trims < TRIM_CAP && orphanLines(cart).length) {
        trims++; setTimeout(syncGifts, 400);
      }
      banner(true); giftNote(); // re-render with real gift names
      drawerInStep(cart);
    }
    var drawnFor = '', drawnN = 0, drawnAt = 0;
    function drawerInStep(cart) {
      try {
        if (!document.querySelector('cart-drawer')) return;
        var want = {}, shown = {};
        (cart.items || []).forEach(function (it) { var v = String(it.variant_id || it.id); if (TAG_IDS.indexOf(v) === -1) want[v] = 1; });
        document.querySelectorAll('cart-drawer li.cart-item a.cart-item__name[href*="variant="]').forEach(function (a) {
          var m = String(a.getAttribute('href') || '').match(/variant=(\d+)/); if (m && TAG_IDS.indexOf(m[1]) === -1) shown[m[1]] = 1; });
        var a = Object.keys(want).sort().join(','), b = Object.keys(shown).sort().join(',');
        if (a === b || syncing) return;
        var giftGone = gifts.some(function (v) { return want[v] && !shown[v]; });
        if (drawnFor === a && !(giftGone && drawnN < 3 && Date.now() - drawnAt > 2500)) return;
        if (drawnFor !== a) drawnN = 0;
        drawnFor = a; drawnN++; drawnAt = Date.now(); refreshCartUI();
      } catch (e) {}
    }
    try {
      var cdEl = document.querySelector('cart-drawer');
      if (cdEl && window.MutationObserver) new MutationObserver(function () {
        if (cdEl.classList.contains('active')) setTimeout(refreshCartState, 300);
      }).observe(cdEl, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
    function refreshCartState() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(namesFromCart).catch(function () {});
    }
    // Add the gift when the chosen variant qualifies, and take it back out when it does
    // not. Only ADDING would mean a customer picks Rose, gets the free bag, switches to
    // black, and still checks out with it -- exactly the case Brian ruled out.
    var syncing = false;
    function syncGifts() {
      if (!gifts.length || syncing) return;
      syncing = true;
      var wanted = giftApplies();
      if (!quiet() && !fast()) { syncing = false; setTimeout(syncGifts, 1400); return; }   // retry, never abandon
      var removed = userRemoved();
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var have = {}; (cart.items || []).forEach(function (it) { have[String(it.variant_id || it.id)] = true; });
        if (wanted && !hasBag(cart)) {   // gifts go in with the bag, and come out with it
          var orphan = orphanLines(cart);
          if (!orphan.length) { syncing = false; return namesFromCart(cart); }
          var upd = {}; orphan.forEach(function (it) { upd[it.key] = 0; });
          return cartWrite('/cart/update.js', { updates: upd })
            .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
            .then(function (c) { syncing = false; namesFromCart(c); });
        }
        if (wanted) {
          try { kcFromCart(cart); } catch (e) {}
          var haveQty = giftQty(cart);
          // How many of each gift we want. Default 1 per order. With lxgiftper, one per
          // qualifying bag -- and still 1 before the customer has added anything, so the
          // gift is visible on the page the way it always was.
          var want = 1;
          if (giftPer) {
            var units = eligibleBagUnits(cart);
            want = units > 0 ? Math.min(units, GIFT_CAP) : 1;
          }
          var toAdd = [], toSet = [];
          gifts.forEach(function (v) {
            if (removed.indexOf(String(v)) !== -1) return;   // they took it out on purpose
            var cur = haveQty[String(v)] || 0;
            if (cur < want) {
              var line = { id: Number(v), quantity: want - cur };
              if (giftPlan[v]) line.selling_plan = Number(giftPlan[v]);
              var gp2 = giftProps(v); if (gp2) line.properties = gp2;
              toAdd.push(line);
            }
            else if (cur > want) {
              // keep `want` in total across the gift's lines, zero the rest; each line by its own key
              var keep = want;
              (cart.items || []).forEach(function (it) {
                if (String(it.variant_id || it.id) !== String(v)) return;
                var q = Math.min(keep, it.quantity || 0); keep -= q;
                if (q !== it.quantity) toSet.push({ id: it.key, quantity: q });
              });
            }
          });
          foreignGiftLines(cart).forEach(function (it) { toSet.push({ id: it.key, quantity: 0 }); });
          if (!toAdd.length && !toSet.length) { syncing = false; return namesFromCart(cart); }
          var addChain = Promise.resolve();
          if (toAdd.length) addChain = addChain.then(function () { return cartWrite('/cart/add.js', { items: toAdd }); });
          toSet.forEach(function (s) { addChain = addChain.then(function () { return cartWrite('/cart/change.js', { id: s.id, quantity: s.quantity }); }); });
          return addChain
            .then(function () { return toAdd.length ? moveBagFirst() : null; })
            .then(function () { document.dispatchEvent(new CustomEvent('lx:gifts-added')); return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
            .then(function (c) { syncing = false; namesFromCart(c); });
        }
        // not eligible -> remove any of OUR gift lines that are in the cart
        var toDrop = gifts.filter(function (v) { return have[v]; });
        if (!toDrop.length) { syncing = false; names = []; banner(true); return; }
        var chain = Promise.resolve();
        toDrop.forEach(function (v) { chain = chain.then(function () { return cartWrite('/cart/change.js', { id: String(v), quantity: 0 }); }); });
        return chain.then(function () { syncing = false; names = []; banner(true); });
      }).catch(function () { syncing = false; });
    }
    if (gifts.length) syncGifts();
    if (chooseOpts.length > 1) {
      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-lxchoice]');
        if (!btn) return;
        e.preventDefault();
        var ni = parseInt(btn.getAttribute('data-lxchoice'), 10);
        if (isNaN(ni) || ni === choice || !chooseOpts[ni]) return;
        var oldVs = gifts.filter(function (v) { return baseGifts.indexOf(v) === -1; });
        choice = ni;
        try { sessionStorage.setItem('lxchoice', String(ni)); } catch (err) {}
        var nv = optVariants(chooseOpts[ni]).slice();
        var saved = null; try { saved = sessionStorage.getItem('lxtag'); } catch (err) {}
        nv = nv.map(function (v) { return (saved && isTag(v) && inSet(TAGS, saved)) ? saved : v; });
        gifts = baseGifts.concat(nv.filter(function (v) { return baseGifts.indexOf(v) === -1; }));
        REMOVED.length = 0;
        var drop = oldVs.filter(function (v) { return gifts.indexOf(v) === -1; });
        banner(true);
        var ch = Promise.resolve();
        drop.forEach(function (v) { ch = ch.then(function () { return cartWrite('/cart/change.js', { id: String(v), quantity: 0 }); }); });
        ch.then(function () { syncGifts(); setTimeout(syncGifts, 1600); });
      }, true);
    }
    if (gifts.length && !giftPer) document.addEventListener('lx:foreign-cart-write', function () { setTimeout(refreshCartState, 1200); });
    if (tagPick || TAGS === TAGS_FREE || chooseOpts.length) {
      document.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[data-lxtag]');
        if (!btn) return;
        e.preventDefault();
        var nv = btn.getAttribute('data-lxtag'), old = curTag();
        if (!old || nv === old || !isTag(nv)) return;
        gifts[gifts.indexOf(old)] = nv;
        try { sessionStorage.setItem('lxtag', nv); } catch (err) {}
        banner(true);
        // take the old colour out, then let syncGifts add the new one (one write queue)
        cartWrite('/cart/change.js', { id: String(old), quantity: 0 }).then(function () { syncGifts(); setTimeout(syncGifts, 1600); });
      }, true);
    }
    // The gift count only tracks the bag count if we re-check after the customer adds
    // bags. We do NOT depend on detecting their write: the foreign-write watcher only
    // patches window.fetch, and this store's bundle app does not add to cart that way,
    // so the event never fires here. Measured: 2 bags, 1 gift.
    // Instead reconcile on a bounded READ-ONLY poll. syncGifts GETs /cart.js first and
    // only writes when the quantity is actually wrong, so a tick costs one GET and a GET
    // cannot cause the write race that produced Brian's "error while updating your cart".
    if (gifts.length && giftPer) {
      var perTicks = 0, perTimer = setInterval(function () {
        if (perTicks++ > 60) { clearInterval(perTimer); return; }   // ~3 minutes, then stop
        syncGifts();
      }, 3000);
      document.addEventListener('lx:foreign-cart-write', function () { setTimeout(syncGifts, 900); });
      document.addEventListener('lx:gifts-added', function () { setTimeout(syncGifts, 1500); });
      window.addEventListener('pagehide', function () { try { clearInterval(perTimer); } catch (e) {} });
    }

    // Keep the unwanted lines out. The app re-adds on its own schedule, so this watches
    // rather than firing once. Only ever touches ids the campaign explicitly listed.
    var dropping = false, dropTries = 0;
    function dropUnwanted() {
      if (!drops.length || dropping) return;
      if (!quiet()) { setTimeout(dropUnwanted, 1400); return; }   // retry, never abandon
      dropping = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var present = {}; (cart.items || []).forEach(function (it) { present[String(it.variant_id || it.id)] = true; });
        var hit = drops.filter(function (v) { return present[v]; });
        if (!hit.length) { dropping = false; return; }
        var chain = Promise.resolve();
        hit.forEach(function (v) { chain = chain.then(function () { return cartWrite('/cart/change.js', { id: String(v), quantity: 0 }); }); });
        return chain.then(function () { dropping = false; document.dispatchEvent(new CustomEvent('lx:dropped')); });
      }).catch(function () { dropping = false; });
    }
    if (drops.length) {
      // Event driven, not a blind timer: the app adds the Guide when the customer clicks
      // Add to Cart, which is long after page load. React to cart writes we observe.
      dropUnwanted();
      document.addEventListener('lx:gifts-added', function () { setTimeout(dropUnwanted, 700); });
      document.addEventListener('lx:foreign-cart-write', function () {
        if (dropTries++ < 40) setTimeout(dropUnwanted, 900);
      });
    }

    function isVisible(el){ return !!(el && el.offsetParent !== null && el.getClientRects().length); }
    function okAnchor(el){ if(!isVisible(el))return false; var r=el.getBoundingClientRect(); return r.height>8 && r.height<320 && r.width<900; } // reject giant wrapping forms
    function buyAnchor(){
      // 1) the actual add-to-cart BUTTON (native + GemPages/custom), a small element
      var btnSels=['button[name="add"]','.product-form__submit','button.gp-button-atc','.gp-button-atc','button[class*="add-to-cart"]','button[class*="AddToCart"]','[class*="add-to-cart"] button','.shopify-payment-button__button'];
      for(var s=0;s<btnSels.length;s++){var els=document.querySelectorAll(btnSels[s]);for(var i=0;i<els.length;i++){if(okAnchor(els[i]))return els[i];}}
      // 2) any visible clickable labelled "add to cart"
      var clk=document.querySelectorAll('button,a,[role="button"],.gp-button');
      for(var j=0;j<clk.length;j++){var t=(clk[j].textContent||'').replace(/\s+/g,' ').trim();if(t.length<40&&/add to (cart|bag)/i.test(t)&&okAnchor(clk[j]))return clk[j];}
      // 3) native button group, reasonably sized
      var pg=document.querySelectorAll('.product-form__buttons');for(var k=0;k<pg.length;k++){if(okAnchor(pg[k]))return pg[k];}
      // 4) visible price fallback (never the hidden native price / giant wrapper)
      var pcs=document.querySelectorAll('.price__container,.price');for(var m=0;m<pcs.length;m++){if(okAnchor(pcs[m]))return pcs[m];}
      return null;
    }

    // 3) banner near the price / buy button
    function banner(force) {
      var existing = document.getElementById('lx-banner');
      if (existing && !force) return;
      var b = existing || document.createElement('div');
      b.id = 'lx-banner';
      b.style.cssText = 'margin:16px 0;padding:14px 16px;border-radius:8px;background:#f6f4ef;border:1px solid rgba(18,18,18,.12);font-family:inherit;line-height:1.45;color:#121212';
      var h = '';
      if (sale) {
        h += '<div style="font:700 11px/1 inherit;letter-spacing:1.1px;text-transform:uppercase;color:#8a6d3b;margin-bottom:9px;">' + esc(sale) + '</div>';
      }
      if (promo) {
        var off = pct ? (pct + '% off') : amt ? (money(amt) + ' off') : bogo ? 'buy 1 get 1 free' : '';
        h += '<div style="display:flex;align-items:flex-start;gap:9px;font-size:14px;font-weight:600;color:#121212;letter-spacing:.2px;">' +
               '<span style="display:inline-flex;align-items:center;justify-content:center;width:19px;height:19px;border-radius:50%;background:#121212;color:#fff;font-size:11px;flex:0 0 auto;margin-top:1px;">&#10003;</span>' +
               '<span>' + (off ? off.charAt(0).toUpperCase() + off.slice(1) : 'Discount') + ' applied. Nothing to type at checkout.</span></div>';
      }
      if (!promo && gifts.length) {
        h += '<div style="display:flex;align-items:flex-start;gap:9px;font-size:14px;font-weight:600;color:#121212;letter-spacing:.2px;">' +
               '<span style="display:inline-flex;align-items:center;justify-content:center;width:19px;height:19px;border-radius:50%;background:#121212;color:#fff;font-size:11px;flex:0 0 auto;margin-top:1px;">&#10003;</span>' +
               '<span>' + ((giftsInCart || bagInCart !== false) ? 'Your gift is already in the cart.' : ('Your free gift' + (gifts.length > 1 ? 's go' : ' goes') + ' into the cart with the bag.')) + ' <b>Nothing to enter at checkout.</b></span></div>';
      }
      if (gifts.length) {
        var eligible = giftApplies();
        var gn = names.length ? names.join(', ') : (gifts.length + ' free gift' + (gifts.length > 1 ? 's' : ''));
        var pad = 'margin-top:' + (promo ? '7px' : '0') + ';padding-left:' + (promo ? '28px' : '0') + ';';
        if (eligible && giftsInCart) {
          if (names.length) h += '<div style="font-size:13px;color:#5b5b5b;' + pad + 'letter-spacing:.2px;">Free gift' + (names.length > 1 ? 's' : '') + ' added: ' + esc(gn) +
               (giftFor.length ? ' <span style="color:#8a6d3b;">\u2014 on ' + esc(giftForLabel()) + ' only</span>' : '') + '</div>';
          if (paidNames.length) h += '<div style="font-size:13px;color:#5b5b5b;' + pad + 'letter-spacing:.2px;">Also added: ' + esc(paidNames.join(', ')) + '</div>';
        } else if (eligible && cartRead && bagInCart) {
          // eligible but not in the cart (the customer removed it). Say so honestly.
          // Gated on cartRead: before the first cart read we do not KNOW it is absent,
          // and saying so contradicts the line directly above it.
          h += '<div style="font-size:13px;color:#8a6d3b;' + pad + 'letter-spacing:.2px;">Your free gift'
             + (giftFor.length ? ' (on ' + esc(giftForLabel()) + ')' : '') + ' is not in the cart \u2014 reload this page to add it back.</div>';
        } else if (!eligible) {
          h += '<div style="font-size:13px;color:#8a6d3b;' + pad + 'letter-spacing:.2px;">The free gift applies to <b>' + esc(giftForLabel()) + '</b> only \u2014 pick one of those to get it.</div>';
        }
      }
      if (chooseOpts.length > 1) {
        var cb = '';
        chooseOpts.forEach(function (o, i) {
          var on = i === choice;
          cb += '<button type="button" data-lxchoice="' + i + '" aria-pressed="' + on + '" style="display:inline-flex;align-items:center;margin:0 6px 6px 0;padding:7px 12px;border-radius:999px;cursor:pointer;font:600 13px/1.2 inherit;color:#121212;background:#fff;border:' + (on ? '2px solid #121212' : '1px solid rgba(18,18,18,.22)') + ';">' + esc(o.label) + '</button>';
        });
        h += '<div id="lx-choose" style="margin-top:10px;padding-left:' + (promo ? '28px' : '0') + ';"><div style="font-size:13px;color:#5b5b5b;margin-bottom:7px;letter-spacing:.2px;">Choose your <b>free gift</b>:</div>' + cb + '</div>';
      }
      var ctag0 = curTag(); if (ctag0) TAGS = inSet(TAGS_FREE, ctag0) ? TAGS_FREE : TAGS_PAID;
      if (ctag0 && (tagPick || TAGS === TAGS_FREE)) {
        var ct = curTag(), sw = '';
        TAGS.forEach(function (t) {
          var on = t[0] === ct;
          sw += '<button type="button" data-lxtag="' + t[0] + '" aria-pressed="' + on + '" style="display:inline-flex;align-items:center;gap:7px;margin:0 6px 6px 0;padding:6px 11px;border-radius:999px;cursor:pointer;font:600 13px/1 inherit;color:#121212;background:#fff;border:' + (on ? '2px solid #121212' : '1px solid rgba(18,18,18,.22)') + ';">' +
                '<span style="width:14px;height:14px;border-radius:50%;background:' + t[2] + ';border:1px solid rgba(0,0,0,.25);"></span>' + t[1] + '</button>';
        });
        h += '<div id="lx-tagpick" style="margin-top:10px;padding-left:' + (promo ? '28px' : '0') + ';">' +
             '<div style="font-size:13px;color:#5b5b5b;margin-bottom:7px;letter-spacing:.2px;">Choose your <b>Find My tag</b> colour:</div>' + sw + '</div>';
      }
      if (preview) {
        h += '<div style="font-size:12.5px;color:#8a6d3b;margin-top:8px;letter-spacing:.2px;">Preview: customers see this from ' + esc(startsAt.toLocaleString()) + '.</div>';
      }
      if (endsAt) {
        h += '<div id="lx-countdown" style="font-size:12.5px;color:#5b5b5b;margin-top:8px;padding-left:' + (promo ? '28px' : '0') + ';letter-spacing:.2px;"></div>';
      }
      b.innerHTML = h;
      if (existing) return; // already placed; we only refreshed its contents
      var a = buyAnchor();
      if (a && a.parentNode) a.parentNode.insertBefore(b, a);
      else document.body.insertBefore(b, document.body.firstChild);
    }

    // 4) dynamic "Your price" line from the product JSON (currency-correct, updates on variant change)
    function priceLine() {
      if (!promo || (!pct && !amt)) return;
      var orig = mainVariantPriceCents();
      if (!orig) return;
      var disc = pct ? Math.round(orig * (1 - pct / 100)) : Math.max(0, orig - amt);
      var box = document.getElementById('lx-price');
      if (box && box.getAttribute('data-v') == String(disc)) return; // unchanged -> stop (no observer loop)
      if (!box) {
        box = document.createElement('div'); box.id = 'lx-price';
        box.style.cssText = 'margin:14px 0 2px;font-family:inherit;display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;';
        var a = buyAnchor();
        if (a && a.parentNode) a.parentNode.insertBefore(box, a); else return;
      }
      box.setAttribute('data-v', String(disc));
      box.innerHTML = '<span style="font-size:14px;color:#9a9a9a;">Regular <s>' + money(orig) + '</s></span>' +
        '<span style="font-size:15px;color:#121212;">Your price <b style="font-size:22px;font-weight:700;letter-spacing:.3px;">' + money(disc) + '</b></span>' +
        '<span style="align-self:center;font-size:10.5px;font-weight:700;letter-spacing:.9px;text-transform:uppercase;background:#121212;color:#fff;padding:3px 8px;border-radius:4px;">' + (pct ? pct + '% off' : money(amt) + ' off') + '</span>';
    }

    // Put the sale name where a duplicated product used to carry it: right by the title.
    var SALE_DONE = false;
    function saleBadge() {
      if (!sale || SALE_DONE) return;
      var h1 = document.querySelector('h1');
      if (!h1) return;
      SALE_DONE = true;
      if (badgeOn && !document.getElementById('lx-sale')) {
        var d = document.createElement('div');
        d.id = 'lx-sale';
        d.textContent = sale;
        d.style.cssText = 'display:inline-block;margin:0 0 8px;padding:5px 11px;border-radius:999px;background:#121212;color:#fff;font:700 10.5px/1 inherit;letter-spacing:1.2px;text-transform:uppercase;';
        h1.parentNode.insertBefore(d, h1);
      }
      try { if (document.title.indexOf(sale) === -1) document.title = sale + ' \u00b7 ' + document.title; } catch (e) {}
      // "all around the page" (Brian): also the announcement bar and any sticky buy bar,
      // which are the two places the duplicated products used to carry the sale name.
      try {
        // This theme's top marquee is `.horizontal-ticker`, NOT `.announcement-bar__message`
        // (measured on the live page 2 Sep). It repeats its items, so inject a copy of the
        // sale name into EVERY ticker container to keep the loop even.
        // 22 Oct 2026 (Arvin: "can we have that at the top?"): appending ONE item at the end never showed.
        // The theme repeats its blocks ~20 times and slides the strip by -50% on a loop, so the last item
        // sat ~6,600px to the right and never came on screen. Put the sale name after EVERY repeat of the
        // blocks instead: both halves stay identical (seamless loop) and it shows once per cycle. The strip
        // gets wider, so the loop time is stretched by the same ratio to keep the scroll speed unchanged.
        var conts = document.querySelectorAll('.horizontal-ticker__container');
        // lxtopbar=1 (Chris, 22 Oct 2026: "have the top banner not scroll and just have that message ... not bolded",
        // "remove the 100k sold and up to 60% off"): the header's bar shows the sale name alone, centred and still.
        var headConts = document.querySelectorAll('.shopify-section-group-header-group .horizontal-ticker__container');
        if (topOnly && (headConts.length || conts.length)) {
          var tc = headConts.length ? headConts : [conts[0]];
          for (var ti = 0; ti < tc.length; ti++) {
            var hc = tc[ti];
            if (hc.getAttribute('data-lx-top') === '1') continue;
            var hp = hc.querySelector('.horizontal-ticker__item');
            var one = hp ? hp.cloneNode(false) : document.createElement('p');
            one.className = ((hp ? hp.className : '') + ' lx-ann').replace(/\bhorizontal-ticker__item--bold\b/g, '').trim();
            one.textContent = sale;
            one.style.cssText = 'font-weight:400;letter-spacing:normal;white-space:normal;text-align:center;line-height:1.3;';
            while (hc.firstChild) hc.removeChild(hc.firstChild);
            hc.appendChild(one);
            hc.setAttribute('data-lx-top', '1');
            hc.style.setProperty('animation', 'none', 'important');
            hc.style.setProperty('transform', 'none', 'important');
            hc.style.setProperty('width', '100%', 'important');
            hc.style.setProperty('justify-content', 'center', 'important');
          }
        } else if (conts.length) {
          for (var ci = 0; ci < conts.length; ci++) {
            var cont = conts[ci];
            if (cont.querySelector('.lx-ann')) continue;
            var kids = [].slice.call(cont.children);
            if (!kids.length) continue;
            var proto = cont.querySelector('.horizontal-ticker__item');
            // compare what shows, not raw HTML: the theme's first copy is indented differently from the repeats
            var sig = kids.map(function (e) { return e.tagName + '|' + String(e.className) + '|' + (e.textContent || '').replace(/\s+/g, ' ').trim() + '|' + (e.getAttribute('src') || ''); });
            var k = 1;
            for (; k <= sig.length / 2; k++) {
              var same = true;
              for (var x = k; x < sig.length; x++) { if (sig[x] !== sig[x - k]) { same = false; break; } }
              if (same) break;
            }
            if (k > sig.length / 2) k = sig.length;
            var wBefore = cont.scrollWidth;
            for (var y = k - 1; y < kids.length; y += k) {
              var it = proto ? proto.cloneNode(true) : document.createElement('p');
              it.className = (proto ? proto.className + ' ' : '') + 'lx-ann';
              it.textContent = sale;
              it.style.cssText = 'font-weight:800;letter-spacing:.6px;';
              kids[y].parentNode.insertBefore(it, kids[y].nextSibling);
            }
            try {
              var wAfter = cont.scrollWidth, dur = parseFloat(getComputedStyle(cont).animationDuration) || 0;
              if (dur > 0 && wBefore > 0 && wAfter > wBefore) cont.style.animationDuration = (dur * wAfter / wBefore).toFixed(2) + 's';
            } catch (e) {}
          }
        } else {
          var ann = document.querySelector('.announcement-bar__message, .announcement-bar, [class*="announcement"] [class*="message"]');
          if (ann && !ann.querySelector('.lx-ann')) {
            var sp = document.createElement('span'); sp.className = 'lx-ann';
            sp.textContent = ' \u00b7 ' + sale + ' \u00b7 ';
            sp.style.cssText = 'font-weight:800;letter-spacing:.6px;';
            ann.appendChild(sp);
          }
        }
        var sticky = document.querySelector('[class*="sticky"][class*="atc"], [class*="sticky-cart"], [class*="stickyBar"], .gp-sticky');
        if (sticky && !sticky.querySelector('.lx-sticky')) {
          var st = document.createElement('div'); st.className = 'lx-sticky';
          st.textContent = sale;
          st.style.cssText = 'font:700 10.5px/1 inherit;letter-spacing:1.1px;text-transform:uppercase;color:#8a6d3b;padding:4px 0;';
          sticky.insertBefore(st, sticky.firstChild);
        }
      } catch (e) {}
    }

    function tick() {
      var el = document.getElementById('lx-countdown');
      if (!el || !endsAt) return;
      var ms = endsAt - new Date();
      if (ms <= 0) { el.textContent = 'This sale has ended.'; return; }
      var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
      el.innerHTML = 'Ends in <b>' + (d ? d + 'd ' : '') + h + 'h ' + m + 'm ' + ss + 's</b>';
    }

    // Walk visible text nodes and correct the design's baked copy. Text nodes only, so
    // no markup, attributes or scripts are touched.
    // The page title and the deal block heading. Runs with the copy fix on every DOM change,
    // because the design and the bundle app both render late and re-render on variant change.
    var prodTitle = null;
    try { fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (p) { prodTitle = p && p.title; applyTitle(); }).catch(function () {}); } catch (e) {}
    function applyTitle() {
      if (!pageTitle) return;
      var known = prodTitle ? prodTitle.toLowerCase() : null;
      var els = document.querySelectorAll('h1, .product__title, [class*="product-title" i], [class*="product_title" i]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || t === pageTitle || t.length > 120) continue;
        var lt = t.toLowerCase();
        var hit = (known && (lt === known || lt.indexOf(known + ' (') === 0)) || /^luhxe travel bag 2\.0\b/.test(lt);
        if (!hit) continue;
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, first = true;
        while ((n = w.nextNode())) {
          if (!n.nodeValue || !n.nodeValue.trim()) continue;
          if (first) { n.nodeValue = pageTitle; first = false; } else n.nodeValue = '';
        }
      }
    }
    function applyDealTitle() {
      var want = sale ? sale : (isDefaultOffer ? '' : null);
      if (want === null) return;
      var els = document.querySelectorAll('.kaching-bundles__block-title');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (want === '') { if (el.style.display !== 'none') el.style.display = 'none'; }
        else if ((el.textContent || '').trim() !== want) el.textContent = want;
      }
    }
    // ---- Buy 1 Get 1 display (lxbogo) ---------------------------------------------------------
    // Edits the bundle app's own text nodes in place (never replaces them), so its next update still
    // lands and is re-read. The FULL price of the two chosen bags comes from the app itself: its struck
    // price when its bar carries a discount, its plain price when it does not.
    var KCFG = null;
    function kachingCfg() {
      if (KCFG) return KCFG;
      try { var el = document.querySelector('script.kaching-bundles-deal-block-settings');
        var j = el && (el.textContent || '').trim() ? JSON.parse(el.textContent) : null; if (j && j.dealBars) KCFG = j; } catch (e) {}
      return KCFG;
    }
    function parseMoney(t) {
      t = String(t || '').replace(/\s+/g, ' ').trim();
      var m = t.match(/\d[\d.,\u00a0\u202f ]*\d|\d/); if (!m) return null;
      var raw = m[0], last = Math.max(raw.lastIndexOf('.'), raw.lastIndexOf(',')), tail = raw.length - last - 1;
      var ds = (last > -1 && tail >= 1 && tail <= 2) ? raw.charAt(last) : '';
      var ip = ds ? raw.slice(0, last) : raw, fp = ds ? raw.slice(last + 1) : '';
      var n = parseFloat(ip.replace(/[^\d]/g, '') + (fp ? '.' + fp : '')); if (isNaN(n)) return null;
      var at = t.indexOf(raw);
      return { n: n, pre: t.slice(0, at), post: t.slice(at + raw.length), dec: ds, thou: (ip.match(/[.,\u00a0\u202f ]/) || [''])[0], d: fp.length };
    }
    function fmtLike(t, n) {
      var d = t.d || 0, f = n.toFixed(d).split('.'), ip = f[0];
      if (t.thou) ip = ip.replace(/\B(?=(\d{3})+(?!\d))/g, t.thou);
      return t.pre + ip + (d ? (t.dec || '.') + f[1] : '') + t.post;
    }
    function setText(el, txt) {
      if (!el) return;
      if ((el.textContent || '') !== txt) {
        var tn = el.childNodes.length === 1 && el.firstChild.nodeType === 3 ? el.firstChild : null;
        if (tn) tn.nodeValue = txt; else el.textContent = txt;
      }
      el.__lxw = txt;
    }
    function tmplRe(tpl) {
      var parts = String(tpl || '').trim().split(/\{\{[^}]*\}\}/);
      return new RegExp('^' + parts.map(function (p) { return p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('.+?') + '$', 'i');
    }
    // price of the variant one bag row has chosen (its colour + model), in the shopper's currency, in cents
    function variantCents(row) {
      if (!PROD || !PROD.variants) return null;
      var vals = [].map.call(row.querySelectorAll('.kaching-bundles-option[data-value]'), function (o) { return String(o.getAttribute('data-value') || '').trim().toLowerCase(); }).filter(Boolean);
      if (!vals.length) return null;
      for (var i = 0; i < PROD.variants.length; i++) {
        var v = PROD.variants[i], parts = String(v.public_title || v.name || '').toLowerCase().split(' / ').map(function (x) { return x.trim(); });
        if (vals.every(function (x) { return parts.indexOf(x) !== -1; })) return Number(v.price) || null;
      }
      return null;
    }
    function fmtCents(t, cents) {
      var d = t.d || (cents % 100 ? 2 : 0);
      return fmtLike({ pre: t.pre, post: t.post, dec: t.dec || (t.thou === '.' ? ',' : '.'), thou: t.thou, d: d }, cents / 100);
    }
    var BOGO_TITLE = 'Buy 1 Get 1 Free', BOGO_PILL = '2ND BAG FREE', bogoBusy = false;
    function applyBogo() {
      if (!bogo || bogoBusy) return;
      bogoBusy = true;
      try {
        var cfg = kachingCfg(), byId = {};
        if (cfg) cfg.dealBars.forEach(function (d) { byId[d.id] = d; });
        var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1');
        var bars = document.querySelectorAll('.kaching-bundles__bar');
        for (var i = 0; i < bars.length; i++) {
          var bar = bars[i], d = byId[bar.getAttribute('data-deal-bar-id')];
          var titleEl = bar.querySelector('.kaching-bundles__bar-title');
          var qty = d ? Number(d.quantity) : (/\b2\b/.test((titleEl || {}).textContent || '') ? 2 : 0);
          if (qty !== 2) continue;
          // only the bundle app's own wording is replaced, so a wording row can still restyle ours
          if (titleEl) { var tt = (titleEl.textContent || '').trim(); if (tt !== BOGO_TITLE && tt !== titleEl.__lxw && (!d || tt === String(d.title || '').trim())) setText(titleEl, BOGO_TITLE); }
          var subEl = bar.querySelector('.kaching-bundles__bar-subtitle');
          if (subEl && d && d.subtitle) { var st = (subEl.textContent || '').trim(); if (st && st !== BOGO_PILL && st !== subEl.__lxw && tmplRe(d.subtitle).test(st)) setText(subEl, BOGO_PILL); }
          var priceEl = bar.querySelector('.kaching-bundles__bar-price'), fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
          if (!priceEl) continue;
          // The price is the two CHOSEN bags' own prices, halved. Not the app's struck price: in USD that is the
          // compare-at total ($400 for two Classics), measured 21 Oct, which made the first version show $200.
          var rows = bar.querySelectorAll('.kaching-bundles__bar-variant-selects'), sum = 0, priced = 0;
          for (var r = 0; r < rows.length; r++) { var vc = variantCents(rows[r]); if (vc) { sum += vc; priced++; } }
          if (rows.length === 1 && priced === 1) { sum *= 2; priced = 2; }
          if (priced !== 2) continue;                 // cannot price both bags: leave the app's own number alone
          var tpl = bar.__lxtpl || parseMoney(priceEl.textContent); if (!tpl) continue; bar.__lxtpl = tpl;
          // the store's own buttons add a cent on a 2-bag price in a non-USD currency; checkout does the same
          var halfTxt = fmtCents(tpl, Math.round(sum / 2) + ((rate && Math.abs(rate - 1) > 1e-9) ? 1 : 0));
          setText(priceEl, halfTxt);
          var ft = fullEl ? (fullEl.textContent || '').trim() : '';
          var fullStr = ft && ft !== fullEl.__lxw ? ft : fmtCents(tpl, sum);   // the app's struck price, else the two bags' total
          if (fullEl) { if ((!ft || ft === fullEl.__lxw) && ft !== fullStr) setText(fullEl, fullStr); if (fullEl.style.display === 'none') fullEl.style.display = ''; }
          else { var f = document.createElement('div'); f.className = 'kaching-bundles__bar-full-price'; f.textContent = fullStr; f.__lxw = fullStr; priceEl.parentNode.insertBefore(f, priceEl.nextSibling); }
          bar.__lxhalf = halfTxt; bar.__lxfullStr = fullStr;
        }
        // the theme's add-to-cart button, its pre-order button and its sticky bar copy the selected bar
        var sel = document.querySelector('.kaching-bundles__bar--selected');
        if (sel && sel.__lxhalf) {
          var half = sel.__lxhalf, fs = sel.__lxfullStr;
          document.querySelectorAll('.cm-new').forEach(function (el) { var t = (el.textContent || '').trim(); if (t && t !== half) setText(el, half); });
          document.querySelectorAll('.cm-old').forEach(function (el) { var t = (el.textContent || '').trim(); if (t && t !== fs) setText(el, fs); });
          var ap = document.getElementById('atcPrice'); if (ap && /\d/.test(ap.textContent || '') && ap.textContent.trim() !== half) setText(ap, half);
          var ac = document.getElementById('atcCompare'); if (ac && (ac.textContent || '').trim() && ac.textContent.trim() !== fs) setText(ac, fs);
          var al = document.getElementById('atcBtnMainLabel'); if (al) { var lm = (al.textContent || '').match(/^(.*\u00b7\s*)(.*\d.*)$/); if (lm && lm[2].trim() !== half) setText(al, lm[1] + half); }
          var dl = document.querySelector('#stickyAtc .sticky-atc__deal'), stt = ((sel.querySelector('.kaching-bundles__bar-title') || {}).textContent || '').trim();
          if (dl && stt && (dl.textContent || '').trim() !== stt) setText(dl, stt);
        }
      } catch (e) {}
      bogoBusy = false;
    }
    var bogoQ = null;
    function queueBogo() { if (!bogo || bogoQ) return; bogoQ = setTimeout(function () { bogoQ = null; applyBogo(); }, 30); }
    // Keep the code on the cart. Applied to an empty cart it waits there and switches on at 2 bags
    // (measured), but a cart that already had a bag when the link was opened can drop it.
    var bogoTries = 0;
    function ensureBogoCode(cart) {
      if (!bogo || !cart || bogoTries >= 4 || !PROD || !PROD.variants) return;
      var ids = {}; PROD.variants.forEach(function (v) { ids[String(v.id)] = 1; });
      var units = 0; (cart.items || []).forEach(function (it) { if (ids[String(it.variant_id || it.id)]) units += it.quantity || 0; });
      if (units < 2) return;
      var has = (cart.discount_codes || []).some(function (c) { return String(c.code || '').toUpperCase() === String(promo).toUpperCase(); });
      if (has) return;
      bogoTries++;
      fetch('/discount/' + encodeURIComponent(promo), { credentials: 'same-origin' }).then(function () { return refreshCartUI(); }).catch(function () {});
    }
    function checkBogoCode() {
      if (!bogo) return;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(ensureBogoCode).catch(function () {});
    }
    function applyCopy() {
      applyTitle(); applyDealTitle(); applyBogo();
      if (!copyRules.length) return;
      var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, svg: 1 };
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var n, hits = 0;
      while ((n = w.nextNode())) {
        if (!n.nodeValue || !n.nodeValue.trim()) continue;
        if (n.parentNode && SKIP[n.parentNode.nodeName]) continue;
        var before = n.nodeValue, after = before;
        for (var i = 0; i < copyRules.length; i++) {
          var r = copyRules[i];
          if (after.toLowerCase().indexOf(r.from.toLowerCase()) === -1) continue;
          after = after.replace(new RegExp(r.from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), r.to);
        }
        if (after !== before) { n.nodeValue = after; hits++; }
      }
      return hits;
    }

    // The theme's variant picker rewrites the URL to ?variant=... and drops the campaign
    // params, so a REFRESH after switching colour lost the whole campaign. Put them back
    // on every history write.
    function keepParams() {
      if (builtinUsed) return;      // the plain address already carries the offer; keep it short
      var KEYS = ['lxpromo','lxpct','lxamt','lxgifts','lxsale','lxbadge','lxgiftstrip','lxtopbar','lxlowstock','lxbanner','lxoffer','lxclaim','lxfrom','lxuntil','lxgiftfor','lxcopy','lxdrop','lxgiftper','lxtagpick','lxpreview','lxchoose','lxtitle','lxbogo','lxppoffer','lxreq'];
      var mine = {};
      KEYS.forEach(function (k) { var v = q.get(k); if (v !== null) mine[k] = v; });
      if (!Object.keys(mine).length) return;
      var restore = function () {
        try {
          var u = new URL(location.href), changed = false;
          Object.keys(mine).forEach(function (k) { if (!u.searchParams.has(k)) { u.searchParams.set(k, mine[k]); changed = true; } });
          if (changed) history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      };
      ['pushState', 'replaceState'].forEach(function (m) {
        var orig = history[m];
        history[m] = function () { var r = orig.apply(this, arguments); setTimeout(restore, 0); return r; };
      });
      window.addEventListener('popstate', restore);
      setInterval(restore, 1200);
      restore();
    }

    // Brian: "we might even want to add copy in the PDP itself to mention that it only
    // applies for Rose and Snow". Put it where the choice is made, not only in the banner.
    function giftNote() {
      if (!giftFor.length || !gifts.length) return;
      // The master's theme page has a native swatch picker; the GemPages sales page has a
      // Kaching combobox instead and matches none of those selectors, so the note simply
      // never rendered there. Fall back to sitting above the buy button, which every
      // design has.
      var host = document.querySelector('[data-id*="options-Color"], variant-radios, variant-selects, .product-form__input, fieldset')
                 || buyAnchor();
      if (!host || !host.parentNode) return;
      var n = document.getElementById('lx-giftnote');
      var txt = 'Free ' + (names.length ? names.join(', ') : 'gift') + ' on ' + giftForLabel() + ' only';
      if (n) { if (n.getAttribute('data-t') !== txt) { n.textContent = txt; n.setAttribute('data-t', txt); } return; }
      n = document.createElement('div');
      n.id = 'lx-giftnote';
      n.setAttribute('data-t', txt);
      n.textContent = txt;
      n.style.cssText = 'margin:8px 0 2px;font:700 11.5px/1.4 inherit;letter-spacing:.3px;color:#8a6d3b;';
      host.parentNode.insertBefore(n, host);
    }

    // The banner must always describe the REAL cart. A read-only /cart.js poll cannot
    // cause the concurrent-write problem, and it catches cart edits the theme makes by
    // XHR or a form post, which the fetch watcher cannot see.
    if (gifts.length) setInterval(function () { refreshCartState(); }, 4000);

    // ---- free-gift strip under Add to Cart (lxgiftstrip=1) ---------------------------------------------------
    // Chris's design, 22 Oct 2026: four tiles, each a FREE pill over the picture, then the name and its value.
    // Names, values and order are his; the pictures were cut from his design and live in Shopify Files.
    var GIFT_TILES = [
      { v: ['47110174769199', '47110174801967', '47110174834735'], name: 'Keychain Tracker', value: '$29 value', img: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-keychain-tracker.png?v=1793724722' },
      { v: ['47025167925295', '44740572643375'], name: 'Cosmetic Bag', value: '$29 value', img: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-cosmetic-bag.png?v=1792681160' },
      { v: ['44740616552495'], name: 'Shoe Bag', value: '$19 value', img: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-shoe-bag.png?v=1792681161' },
      { v: ['47115101962287'], name: 'e-Gift Card', value: '$50 value', img: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-egift-card-50.png?v=1793724727' },
      { v: ['47042706047023', '47015322058799'], name: 'e-Gift Card', value: '$25 value', img: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-egift-card.png?v=1792681160' },
      { v: ['43134073045039', '47044500684847'], name: 'Travel Guide', value: '$29 value', img: 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-gift-travel-guide.png?v=1792681160' }
    ];
    function giftStripRender() {
      if (!giftStrip || document.getElementById('lx-giftstrip')) return;
      var tiles = GIFT_TILES.filter(function (t) { return t.v.some(function (v) { return gifts.indexOf(v) !== -1; }); });
      if (!tiles.length) return;
      var btn = null, bs = document.querySelectorAll('button.gp-button-atc, button.gp-button-sold-out');
      for (var i = 0; i < bs.length; i++) { var r = bs[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) { btn = bs[i]; break; } }
      if (!btn) return;
      var box = btn.closest('gp-product-button') || btn.parentNode, after = box;
      // keep the store's "Low Stock" line right under the button: the strip goes below it
      var nx = box.nextElementSibling;
      while (nx && /^(SCRIPT|STYLE|TEMPLATE)$/.test(nx.tagName)) nx = nx.nextElementSibling;
      if (nx && /low stock/i.test(nx.textContent || '') && nx.getBoundingClientRect().height < 90) after = nx;
      var ob = document.getElementById('lx-offerbox');
      if (ob && ob.parentNode === after.parentNode) after = ob;
      if (!document.getElementById('lx-giftstrip-css')) {
        var st = document.createElement('style'); st.id = 'lx-giftstrip-css';
        st.textContent =
          '#lx-giftstrip{display:grid;grid-template-columns:repeat(' + tiles.length + ',minmax(0,1fr));gap:12px;margin:4px 0 6px;width:100%;box-sizing:border-box;letter-spacing:normal;text-transform:none}' +
          '#lx-giftstrip .lxg{text-align:center;min-width:0;display:flex;flex-direction:column}' +
          '#lx-giftstrip .lxg-card{position:relative;margin-top:12px}' +
          '#lx-giftstrip .lxg-card img{display:block;width:100%;height:auto;aspect-ratio:1/1;border-radius:10%;background:#f6f4f2}' +
          '#lx-giftstrip .lxg-pill{position:absolute;top:0;left:50%;transform:translate(-50%,-50%);background:#fff;border:1.5px solid #121212;border-radius:999px;padding:4px 11px 3px;font:800 10px/1.1 Helvetica,Arial,sans-serif;letter-spacing:2px;color:#121212;white-space:nowrap}' +
          '#lx-giftstrip .lxg-name{margin-top:8px;font-family:inherit;font-size:13px;line-height:1.25;font-weight:500;color:#1c1c1c;letter-spacing:normal;word-break:normal;hyphens:none}' +
          '#lx-giftstrip .lxg-val{margin-top:auto;padding-top:3px;font-family:inherit;font-size:12px;line-height:1.2;font-weight:400;color:#6f6f6f;letter-spacing:normal}' +
          '@media (max-width:480px){#lx-giftstrip{gap:8px}#lx-giftstrip .lxg-name{font-size:11.5px}#lx-giftstrip .lxg-val{font-size:11px}#lx-giftstrip .lxg-pill{font-size:9px;letter-spacing:1.5px;padding:3px 8px 2px}}';
        document.head.appendChild(st);
      }
      var wrap = document.createElement('div'); wrap.id = 'lx-giftstrip';
      wrap.innerHTML = tiles.map(function (t) {
        return '<div class="lxg"><div class="lxg-card"><span class="lxg-pill">FREE</span><img src="' + esc(t.img) + '&width=400" alt="Free ' + esc(t.name) + '" loading="lazy" width="429" height="429"></div>' +
               '<div class="lxg-name">' + esc(t.name) + '</div><div class="lxg-val">' + esc(t.value) + '</div></div>';
      }).join('');
      after.parentNode.insertBefore(wrap, after.nextSibling);
    }

    // lxlowstock=0 (Chris, 22 Oct 2026: "remove the low stock remaining ... the red blinking thing"): hide the design's
    // "Warning: Low Stock Remaining" row. Found by its words, since the element id belongs to one GemPages design.
    var lowRowEl = null;
    function hideLowStock() {
      if (!hideLow) return;
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        if (!/low stock remaining/i.test(n.nodeValue || '')) continue;
        var el = n.parentElement, row = el && el.closest ? el.closest('gp-row') : null;
        // only the small row that holds the warning, never a big section that happens to contain it
        // visible words only (innerText): the row also carries the dot's CSS animation in a <style>, which textContent counts
        var hit = (row && (row.innerText || '').replace(/\s+/g, ' ').trim().length < 80) ? row : el;
        if (hit && hit.style.display !== 'none') hit.style.setProperty('display', 'none', 'important');
        if (hit) lowRowEl = hit;
      }
    }

    // lxoffer / lxclaim: Chris's offer box (22 Oct 2026, his HTML and CSS) where the Low Stock line was.
    // Chris's CSS, scoped to the box's id: the page's own paragraph rules out-rank plain class selectors here (measured: his
    // 19px bold title came out 16px regular with the page's 0.96px letter-spacing). Letter-spacing normal, as in his preview.
    var OB = '#lx-offerbox';
    var OFFER_CSS =
      OB + '.lx-offer{box-sizing:border-box;width:100%;margin:14px 0 20px;padding:10px 18px 12px;border-radius:16px;background:#F5F4F2;color:#121212;font-family:var(--font-body-family,"Harmonia Sans",sans-serif);text-align:center;letter-spacing:normal}' +
      OB + ' *{box-sizing:border-box;letter-spacing:normal}' +
      OB + ' .lx-offer__title{margin:0 0 6px;font-family:var(--font-heading-family,Poppins,sans-serif);font-size:19px;font-weight:700;line-height:1.35;color:#121212;text-transform:none;text-wrap:balance}' +
      OB + ' .lx-offer__accent{color:#DD1D1D;font-weight:700}' +
      OB + ' .lx-offer__row{display:flex;align-items:center;gap:12px;width:100%}' +
      OB + ' .lx-offer__dot{flex:0 0 auto;width:7px;height:7px;border-radius:999px;background:#B01515;animation:lxOfferDot 1.6s ease-out infinite}' +
      OB + ' .lx-offer__label{flex:0 0 auto;font-size:14px;font-weight:400;white-space:nowrap}' +
      OB + ' .lx-offer__count{margin-left:2px;font-family:var(--font-heading-family,Poppins,sans-serif);font-weight:600;letter-spacing:.02em}' +
      OB + ' .lx-offer__sep{margin:0 4px;font-weight:400;color:#8A8580}' +
      OB + ' .lx-offer__track{flex:1 1 auto;min-width:60px;height:8px;border-radius:999px;background:#E4E1DD}' +
      OB + ' .lx-offer__fill{display:block;height:100%;border-radius:999px;background:#DD1D1D;animation:lxOfferGlow 1.6s ease-in-out infinite}' +
      '@keyframes lxOfferGlow{0%,100%{opacity:1;box-shadow:0 0 4px rgba(221,29,29,.45),0 0 10px rgba(221,29,29,.25)}50%{opacity:.72;box-shadow:0 0 12px rgba(221,29,29,.85),0 0 26px rgba(221,29,29,.45)}}' +
      '@keyframes lxOfferDot{0%{box-shadow:0 0 0 0 rgba(176,21,21,.55)}70%{box-shadow:0 0 0 7px rgba(176,21,21,0)}100%{box-shadow:0 0 0 0 rgba(176,21,21,0)}}' +
      '@media (max-width:749px){' + OB + '.lx-offer{padding:9px 12px 10px;border-radius:14px;margin-bottom:16px}' + OB + ' .lx-offer__title{font-size:14px;margin-bottom:5px}' +
        OB + ' .lx-offer__row{gap:8px}' + OB + ' .lx-offer__dot{width:6px;height:6px}' + OB + ' .lx-offer__label{font-size:12.5px}' + OB + ' .lx-offer__sep{margin:0 3px}' + OB + ' .lx-offer__track{height:6px}}';
    function offerBoxRender() {
      if (!(offerTitle || offerAccent) || document.getElementById('lx-offerbox')) return;
      var anchor = lowRowEl;
      if (!anchor) {
        var bs = document.querySelectorAll('button.gp-button-atc, button.gp-button-sold-out'), btn = null;
        for (var i = 0; i < bs.length; i++) { var r = bs[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) { btn = bs[i]; break; } }
        if (!btn) return;
        anchor = btn.closest('gp-product-button') || btn.parentNode;
      }
      if (!document.getElementById('lx-offer-css')) { var st = document.createElement('style'); st.id = 'lx-offer-css'; st.textContent = OFFER_CSS; document.head.appendChild(st); }
      var box = document.createElement('div'); box.id = 'lx-offerbox'; box.className = 'lx-offer';
      var h = '<p class="lx-offer__title">' + esc(offerTitle) + (offerAccent ? (offerTitle ? ' ' : '') + '<span class="lx-offer__accent">' + esc(offerAccent) + '</span>' : '') + '</p>';
      if (claimM) {
        var got = parseInt(claimM[1], 10), of = parseInt(claimM[2], 10), pctFill = of > 0 ? Math.max(0, Math.min(100, got / of * 100)) : 0;
        h += '<div class="lx-offer__row"><span class="lx-offer__dot"></span>' +
             '<span class="lx-offer__label">Gifts claimed <strong class="lx-offer__count">' + got + '<span class="lx-offer__sep">/</span>' + of + '</strong></span>' +
             '<span class="lx-offer__track"><span class="lx-offer__fill" style="width:' + (Math.round(pctFill * 10) / 10) + '%"></span></span></div>';
      }
      box.innerHTML = h;
      anchor.parentNode.insertBefore(box, anchor.nextSibling);
    }
    // lxbanner=0: the banner re-renders itself on cart changes, so hide it with a rule rather than removing it
    function bannerOff() {
      if (bannerOn || document.getElementById('lx-banner-off')) return;
      var st = document.createElement('style'); st.id = 'lx-banner-off'; st.textContent = '#lx-banner{display:none!important}';
      document.head.appendChild(st);
    }

    // ---- Protection+ panel under Add to Cart (lxppoffer=1, Chris's design 28 Oct 2026) ------------------------------
    var PP_TERMS = '/pages/luhxe-protection-plus-terms';
    var PP_CSS = '#lx-pp{box-sizing:border-box;width:100%;margin:2px 0 6px;letter-spacing:normal;text-transform:none;color:#2b2222;font-family:var(--font-body-family,"Harmonia Sans",sans-serif)}' +
      '#lx-pp .lxpp-card{background:#f4f0ec;border:1px solid #e7e0d9;border-radius:22px;padding:16px 16px 14px}' +
      '#lx-pp .lxpp-h{margin:0;text-align:center;font-family:var(--font-heading-family,Poppins,sans-serif);font-size:22px;line-height:1.15;font-weight:700;color:#2b2222;text-wrap:balance}' +
      '#lx-pp .lxpp-h span{display:block;color:#b0261a}' +
      '#lx-pp .lxpp-sub{margin:4px 0 8px;text-align:center;font-size:15px;color:#6b6262}' +
      '#lx-pp svg{display:inline-block!important;flex:0 0 auto}#lx-pp .lxpp-sub svg{vertical-align:-3px;margin-right:6px}' +
      '#lx-pp .lxpp-gifts{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px}' +
      '#lx-pp .lxpp-g{text-align:center;min-width:0}' +
      '#lx-pp .lxpp-gc{position:relative;margin-top:9px;background:#fff;border-radius:14px;padding:10px 8px 6px}' +
      '#lx-pp .lxpp-gc img{display:block;width:100%;height:auto;aspect-ratio:1/1;object-fit:contain;border-radius:8px}' +
      '#lx-pp .lxpp-pill{position:absolute;top:0;left:50%;transform:translate(-50%,-50%);background:#2b2222;color:#fff;border-radius:999px;padding:4px 10px 3px;font:800 10px/1.1 Helvetica,Arial,sans-serif;letter-spacing:1.5px}' +
      '#lx-pp .lxpp-gn{margin-top:5px;font-weight:700;font-size:13.5px;line-height:1.15;color:#2b2222}' +
      '#lx-pp .lxpp-gv{margin-top:1px;font-size:12.5px;color:#6b6262}' +
      '#lx-pp .lxpp-plus{margin:12px 0 7px;text-align:center;font-size:12px;line-height:1.3;font-weight:700;letter-spacing:1.2px;color:#6b6262;text-transform:uppercase}' +
      '#lx-pp .lxpp-list{background:#fff;border:1px solid #e7e0d9;border-radius:16px;padding:0 12px}' +
      '#lx-pp .lxpp-row{display:flex;align-items:center;gap:10px;padding:8px 0;border-top:1px solid #ece6e0;font-size:13px;line-height:1.2;letter-spacing:-.1px}' +
      '#lx-pp .lxpp-row:first-child{border-top:0}' +
      '#lx-pp .lxpp-ic{flex:0 0 28px;width:28px;height:28px;border-radius:999px;background:#f7e9e6;display:flex;align-items:center;justify-content:center}' +
      '#lx-pp .lxpp-row b{font-weight:700}' +
      '#lx-pp .lxpp-im{display:inline-block;margin-left:3px;background:#e6efff;color:#1b5fe0;border-radius:999px;padding:1px 7px;font-weight:700;font-size:.9em;line-height:1.3;white-space:nowrap}' +
      '#lx-pp .lxpp-sum{list-style:none;margin:14px 0 0;padding:0 17px 14px;border-bottom:1px solid #ddd5cd}' +
      '#lx-pp .lxpp-sum li{display:flex;gap:10px;margin:0 0 6px;padding:0;font-size:14.5px;line-height:1.35;color:#2b2222}#lx-pp .lxpp-sum li:last-child{margin-bottom:0}' +
      '#lx-pp .lxpp-sum li:before{content:none}#lx-pp .lxpp-ck{flex:0 0 auto;color:#b0261a;font-weight:700}#lx-pp .lxpp-sum b{font-weight:700}' +
      '#lx-pp.is-off .lxpp-sum{display:none}' +
      '#lx-pp .lxpp-off{display:block;margin:14px auto 0;background:none;border:0;padding:0 0 2px;border-bottom:1.5px solid #2b2222;font:600 13.5px/1.3 var(--font-body-family,"Harmonia Sans",sans-serif);letter-spacing:1.4px;text-transform:uppercase;color:#2b2222;cursor:pointer}' +
      '#lx-pp .lxpp-rec{margin:8px 0 0;text-align:center;font-size:13.5px;line-height:1.4;color:#6b6262}' +
      '#lx-pp .lxpp-rec b{color:#2b2222}' +
      '#lx-pp .lxpp-terms{display:block;width:max-content;margin:6px auto 0;padding:0;background:none;border:0;font:inherit;font-size:13px;color:#6b6262;text-decoration:underline;cursor:pointer}' +
      '#lx-pp .lxpp-done{display:none;margin:12px 0 0;text-align:center;font-size:13.5px;color:#2b2222}' +
      '#lx-pp.is-off .lxpp-done{display:block}' +
      '@media (max-width:480px){#lx-pp .lxpp-card{padding:13px 10px 11px;border-radius:18px}#lx-pp .lxpp-h{font-size:18px}#lx-pp .lxpp-sub{font-size:13.5px}' +
        '#lx-pp .lxpp-gifts{gap:7px}#lx-pp .lxpp-gc{padding:8px 5px 4px;border-radius:11px}#lx-pp .lxpp-gn{font-size:11.5px}#lx-pp .lxpp-gv{font-size:11px}' +
        '#lx-pp .lxpp-pill{font-size:9px;padding:3px 8px 2px}#lx-pp .lxpp-plus{font-size:10.5px;letter-spacing:.6px;margin:10px 0 6px}#lx-pp .lxpp-list{padding:0 8px}#lx-pp .lxpp-row{font-size:11.5px;gap:7px;padding:6px 0;letter-spacing:-.15px}#lx-pp .lxpp-ic{flex-basis:22px;width:22px;height:22px}#lx-pp .lxpp-ic svg{width:13px;height:13px}' +
        '#lx-pp .lxpp-sum{margin-top:12px;padding:0 11px 12px}#lx-pp .lxpp-sum li{font-size:13px;gap:8px;margin-bottom:5px}#lx-pp .lxpp-off{font-size:12px;letter-spacing:1.1px;margin-top:12px}#lx-pp .lxpp-rec{font-size:12.5px;margin-top:6px}}@media (max-width:380px){#lx-pp .lxpp-row{font-size:11px;letter-spacing:-.2px}}';
    var IC = function (d) { return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#b0261a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
    var SHIELD = '<path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/>';
    function atcButton() {
      var bs = document.querySelectorAll('button.gp-button-atc, button.gp-button-sold-out');
      for (var i = 0; i < bs.length; i++) { var r = bs[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return bs[i]; }
      return null;
    }
    function reqPrice() {
      // the plan's own price, read from the storefront: "$0 today, then $19.99/month" or "$19.99/month"
      if (!REQ || !REQ.handle || REQ.priceAsked) return;
      REQ.priceAsked = true;
      fetch('/products/' + encodeURIComponent(REQ.handle) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (p) {
        var vv = (p.variants || []).filter(function (x) { return String(x.id) === REQ.v; })[0]; if (!vv) return;
        var al = (vv.selling_plan_allocations || []).filter(function (a) { return String(a.selling_plan_id) === REQ.plan; })[0]; if (!al) return;
        var adj = al.price_adjustments || [], first = adj.length ? adj[0].price : al.price, later = adj.length > 1 ? adj[1].price : al.price;
        REQ.price = (first === later) ? money(later) + '/month' : money(first) + ' today, then ' + money(later) + '/month';
        var el = document.querySelector('#lx-pp [data-lxreqprice]'); if (el) el.textContent = REQ.price; var sb = document.querySelector('#lx-pp [data-lxreqsub]'); if (sb) sb.textContent = '(' + REQ.price + ')';
      }).catch(function () {});
    }
    function reqHtml(tiles) {
      var names = tiles.length ? '' : '<p class="lxpp-sub">' + gifts.filter(function (v) { return v !== REQ.v && REQ.extra.indexOf(v) === -1; }).length + ' free gifts</p>';
      return '<div class="lxpp-card">' +
        '<p class="lxpp-h">FREE gifts with <span>' + esc(REQ.label) + '</span></p>' +
        '<p class="lxpp-sub">' + IC(SHIELD) + 'Add ' + esc(REQ.label) + ' <span data-lxreqsub>' + (REQ.price ? '(' + esc(REQ.price) + ')' : '') + '</span> to your order and these come free</p>' + names +
        (tiles.length ? '<div class="lxpp-gifts">' + tiles.map(function (t) {
          return '<div class="lxpp-g"><div class="lxpp-gc"><span class="lxpp-pill">FREE</span><img src="' + esc(t.img) + '&width=300" alt="Free ' + esc(t.name) + '" loading="lazy" width="300" height="300"></div>' +
                 '<div class="lxpp-gn">' + esc(t.name) + '</div><div class="lxpp-gv">' + esc(t.value) + '</div></div>';
        }).join('') + '</div>' : '') +
      '</div>' +
      '<ul class="lxpp-sum">' +
        '<li style="line-height:1.5"><span class="lxpp-ck">&#10003;</span><span>Luhxe Travel Bag 2.0 + your free gifts</span></li>' +
        '<li style="line-height:1.5"><span class="lxpp-ck">&#10003;</span><span style="font-weight:400">' + esc(REQ.label) + ' &middot; <span data-lxreqprice>' + esc(REQ.price || 'billed monthly') + '</span>. Cancel anytime.</span></li>' +
      '</ul>' +
      '<button type="button" class="lxpp-off" data-lxppoff="1">Add to cart without the free gifts &rarr;</button>' +
      '<p class="lxpp-done">Added without ' + esc(REQ.label) + ' and the free gifts. Tap Add to Cart above to add them back.</p>';
    }
    function ppRender() {
      if ((!OFFER && !PPGIFT) || document.getElementById('lx-pp')) return;
      var btn = atcButton(); if (!btn) return;
      if (!document.getElementById('lx-pp-css')) { var st = document.createElement('style'); st.id = 'lx-pp-css'; st.textContent = PP_CSS; document.head.appendChild(st); }
      var box = btn.closest('gp-product-button') || btn.parentNode, after = box;
      var nx = box.nextElementSibling;
      while (nx && /^(SCRIPT|STYLE|TEMPLATE)$/.test(nx.tagName)) nx = nx.nextElementSibling;
      if (nx && /low stock/i.test(nx.textContent || '') && nx.getBoundingClientRect().height < 90) {
        after = nx;
        // its warning never shows on this page, so the row was only a 25px blank + 20px margin above the panel
        // (28 Oct, Chris: "remove some spacing here")
        nx.style.setProperty('display', 'none', 'important');
      }
      var tiles = GIFT_TILES.filter(function (t) { return t.v.some(function (v) { return gifts.indexOf(v) !== -1; }); });
      var wrap = document.createElement('div'); wrap.id = 'lx-pp';
      if (ppOff) wrap.className = 'is-off';
      if (REQ) { reqPrice(); wrap.innerHTML = reqHtml(tiles); after.parentNode.insertBefore(wrap, after.nextSibling); return; }
      if (!OFFER) {   // 03 Nov 2026: gift box only, no Protection+ copy, no decline link, no terms
        wrap.className = 'is-giftonly';
        wrap.innerHTML = '<div class="lxpp-card">' +
          '<p class="lxpp-h">' + esc(PPHEAD) + ': <span>' + PPVAL + ' in FREE Gifts!</span></p>' +
          '<div class="lxpp-gifts">' + tiles.map(function (t) {
            return '<div class="lxpp-g"><div class="lxpp-gc"><span class="lxpp-pill">FREE</span><img src="' + esc(t.img) + '&width=300" alt="Free ' + esc(t.name) + '" loading="lazy" width="300" height="300"></div>' +
                   '<div class="lxpp-gn">' + esc(t.name) + '</div><div class="lxpp-gv">' + esc(t.value) + '</div></div>';
          }).join('') + '</div>' +
          // 03 Nov 2026: Black Friday's 5th gift (Chris: "24/7 Concierge - same as we had before"), no cart line, no subscription
          (PPBF ? '<div class="lxpp-list" style="margin-top:12px"><div class="lxpp-row"><span class="lxpp-ic">' + IC('<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1.1-4.6A8 8 0 1 1 21 12z"/>') +
                  '</span><span><b>24/7 AI Travel Concierge</b> via <span class="lxpp-im">&#9679; iMessage</span> <span style="display:inline-block;margin-left:4px;background:#2b2222;color:#fff;border-radius:999px;padding:1px 8px;font-weight:700;font-size:.9em;line-height:1.35;white-space:nowrap">$25 value</span></span></div></div>' : '') +
          '</div>';
        after.parentNode.insertBefore(wrap, after.nextSibling); return;
      }
      wrap.innerHTML = '<div class="lxpp-card">' +
        '<p class="lxpp-h">' + esc(PPHEAD) + ': <span>$102 in FREE Gifts!</span></p>' +
        '<p class="lxpp-sub">' + IC(SHIELD) + 'Included with Luhxe Protection+</p>' +
        '<div class="lxpp-gifts">' + tiles.map(function (t) {
          return '<div class="lxpp-g"><div class="lxpp-gc"><span class="lxpp-pill">FREE</span><img src="' + esc(t.img) + '&width=300" alt="Free ' + esc(t.name) + '" loading="lazy" width="300" height="300"></div>' +
                 '<div class="lxpp-gn">' + esc(t.name) + '</div><div class="lxpp-gv">' + esc(t.value) + '</div></div>';
        }).join('') + '</div>' +
        '<p class="lxpp-plus">Plus, everything else in Luhxe Protection+</p>' +
        '<div class="lxpp-list">' +
          '<div class="lxpp-row"><span class="lxpp-ic">' + IC('<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1.1-4.6A8 8 0 1 1 21 12z"/>') + '</span><span><b>24/7 Personal Travel Concierge</b> via <span class="lxpp-im">&#9679; iMessage</span></span></div>' +
          '<div class="lxpp-row"><span class="lxpp-ic">' + IC(SHIELD) + '</span><span><b>Lifetime warranty</b>, get a new bag anytime, forever</span></div>' +
          '<div class="lxpp-row"><span class="lxpp-ic">' + IC('<line x1="19" y1="5" x2="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/>') + '</span><span><b>20% off</b> all future orders, for life</span></div>' +
          '<div class="lxpp-row"><span class="lxpp-ic">' + IC('<rect x="1" y="7" width="13" height="10" rx="1"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>') + '</span><span><b>$0 shipping</b> on all future orders</span></div>' +
          '<div class="lxpp-row"><span class="lxpp-ic">' + IC('<path d="M12 3l1.8 4.6L18 9l-4.2 1.4L12 15l-1.8-4.6L6 9l4.2-1.4z"/><path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>') + '</span><span><b>New releases</b> 3 days before anyone else + 40% off</span></div>' +
        '</div>' +
      '</div>' +
      // what is in the order, with the recurring charge spelled out (28 Oct, Kira: "be clear they're going to be charged again and
      // mention the $$ amount monthly"; Chris's line, in the style of the LX-68 cosmetic-bag test)
      '<ul class="lxpp-sum">' +
        '<li style="line-height:1.5"><span class="lxpp-ck">&#10003;</span><span>Luhxe Travel Bag 2.0 + $102 in Free Gifts</span></li>' +
        '<li style="line-height:1.5"><span class="lxpp-ck">&#10003;</span><span style="font-weight:400">Luhxe Protection Plus &middot; $0 today, $24.99/mo after free 7-Day Trial + Skip, pause or cancel anytime</span></li>' +
        '<li style="line-height:1.5"><span class="lxpp-ck">&#10003;</span><span>Free Shipping + 20% Off Every Future Order + 24/7 Travel Concierge</span></li>' +
      '</ul>' +
      '<button type="button" class="lxpp-off" data-lxppoff="1">Add to cart without $102 in free gifts &rarr;</button>' +
      '<p class="lxpp-rec">We recommend Protection+ so you keep your <b>$102 in free gifts</b>, <b>lifetime warranty</b>, and <b>20% off</b> every order.</p>' +
      '<p class="lxpp-done">Added without Protection+ and the free gifts. Tap Add to Cart above to add them back.</p>' +
      '<a class="lxpp-terms" href="' + PP_TERMS + '" target="_blank" rel="noopener" data-lxppterms="1">Terms</a>';
      after.parentNode.insertBefore(wrap, after.nextSibling);
    }
    function setPpOff(off) {
      ppOff = !!off;
      try { if (ppOff) sessionStorage.setItem(PPKEY, '1'); else sessionStorage.removeItem(PPKEY); } catch (e) {}
      var w = document.getElementById('lx-pp'); if (w) w.classList.toggle('is-off', ppOff);
      if (!ppOff) REMOVED.length = 0;    // choosing the gifts again restores anything taken out
    }
    // Terms open in a scrollable popup instead of leaving the page (28 Oct 2026, Chris: "the way we did before" = the LX-68
    // Protection+ terms modal). Text comes from the live Terms page, so there is one copy to edit; if it cannot be read the
    // link opens the page as before.
    var PPM_CSS = '#lx-ppm{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:20px;font-family:var(--font-body-family,"Harmonia Sans",sans-serif);letter-spacing:normal;text-transform:none}' +
      '#lx-ppm.is-open{display:flex}#lx-ppm *{box-sizing:border-box}' +
      '#lx-ppm .lxppm-ov{position:absolute;inset:0;background:rgba(18,18,18,.55);border:0;padding:0;margin:0;cursor:pointer}' +
      '#lx-ppm .lxppm-panel{position:relative;width:100%;max-width:560px;max-height:80vh;display:flex;flex-direction:column;background:#fff;border-radius:14px;box-shadow:0 18px 60px rgba(0,0,0,.28);overflow:hidden}' +
      '#lx-ppm .lxppm-head{flex:0 0 auto;display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:18px 20px 12px;border-bottom:1px solid #ece7e0}' +
      '#lx-ppm .lxppm-title{margin:0;font-size:17px;line-height:1.3;font-weight:700;color:#1c1917}' +
      '#lx-ppm .lxppm-x{flex:0 0 auto;width:34px;height:34px;margin:-6px -6px 0 0;padding:0;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:transparent;color:#4b4641;cursor:pointer;font-size:22px;line-height:1}' +
      '#lx-ppm .lxppm-body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:14px 20px 22px;font-size:13.5px;line-height:1.55;color:#4b4641}' +
      '#lx-ppm .lxppm-body h1{display:none}#lx-ppm .lxppm-body h2,#lx-ppm .lxppm-body h3,#lx-ppm .lxppm-body h4{margin:16px 0 5px;font-size:14px;line-height:1.4;font-weight:700;color:#1c1917;letter-spacing:normal;text-transform:none}' +
      '#lx-ppm .lxppm-body p,#lx-ppm .lxppm-body li{margin:0 0 9px;font-size:13.5px;line-height:1.55;color:#4b4641}#lx-ppm .lxppm-body ul{margin:0 0 9px;padding-left:18px}#lx-ppm .lxppm-body a{color:#382929;text-decoration:underline}' +
      '@media (max-width:749px){#lx-ppm{padding:0;align-items:flex-end}#lx-ppm .lxppm-panel{max-width:100%;max-height:88vh;border-radius:14px 14px 0 0}}';
    var ppmHtml = null;
    function ppmClose() {
      var m = document.getElementById('lx-ppm'); if (m) m.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    function ppmOpen() {
      var m = document.getElementById('lx-ppm');
      if (!m) {
        if (!document.getElementById('lx-ppm-css')) { var st = document.createElement('style'); st.id = 'lx-ppm-css'; st.textContent = PPM_CSS; document.head.appendChild(st); }
        m = document.createElement('div'); m.id = 'lx-ppm'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
        m.innerHTML = '<button type="button" class="lxppm-ov" aria-label="Close"></button><div class="lxppm-panel">' +
          '<div class="lxppm-head"><p class="lxppm-title">Luhxe Protection+ Terms</p><button type="button" class="lxppm-x" aria-label="Close">&times;</button></div>' +
          '<div class="lxppm-body">Loading&hellip;</div></div>';
        m.addEventListener('click', function (e) { if (e.target.closest('.lxppm-ov, .lxppm-x')) ppmClose(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ppmClose(); });
        document.body.appendChild(m);
      }
      m.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var x = m.querySelector('.lxppm-x'); if (x) x.focus();
      if (ppmHtml) return;
      fetch(PP_TERMS, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var c = d.querySelector('.lxpp-terms-page') || d.querySelector('main .rte');
        if (!c) throw 0;
        var h = d.querySelector('main h1');
        if (h && h.textContent.trim()) m.querySelector('.lxppm-title').textContent = h.textContent.trim();
        ppmHtml = c.innerHTML;
        m.querySelector('.lxppm-body').innerHTML = ppmHtml;
      }).catch(function () { ppmClose(); location.href = PP_TERMS; });
    }
    var ppViaOff = false;
    if (OFFER) {
      if (PPO) document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('[data-lxppterms]');
        if (!t) return;
        e.preventDefault();
        ppmOpen();
      }, true);
      // the page's own Add to Cart (main or sticky) is the "with Protection+ and the gifts" button
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('button.gp-button-atc, .sticky-atc__btn');
        if (!t || ppViaOff) return;
        if (ppOff) setPpOff(false);
      }, true);
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('[data-lxppoff]');
        if (!t) return;
        e.preventDefault();
        setPpOff(true);
        var btn = atcButton();
        // take the membership and every gift out in ONE write (one line at a time took 20s+ while the other apps were busy),
        // then add the bag alone; syncGifts afterwards is only a safety net
        var drop = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          var upd = {}, n = 0;
          (cart.items || []).forEach(function (it) { if (gifts.indexOf(String(it.variant_id || it.id)) !== -1) { upd[it.key] = 0; n++; } });
          if (n) return cartWrite('/cart/update.js', { updates: upd });
        }).catch(function () {});
        drop.then(function () {
          if (btn) { ppViaOff = true; try { btn.click(); } finally { setTimeout(function () { ppViaOff = false; }, 0); } }
          setTimeout(syncGifts, 2500); setTimeout(syncGifts, 6000);
        });
      }, true);
      var ppN = 0, ppT = setInterval(function () { if (++ppN > 20 || document.getElementById('lx-pp')) return clearInterval(ppT); ppRender(); }, 750);
    } else if (PPGIFT) {   // 03 Nov 2026: gift box only (Protection+ off)
      var pgN = 0, pgT = setInterval(function () { if (++pgN > 20 || document.getElementById('lx-pp')) return clearInterval(pgT); ppRender(); }, 750);
    }
    function run() { saleBadge(); banner(); bannerOff(); priceLine(); tick(); applyCopy(); giftNote(); hideLowStock(); offerBoxRender(); giftStripRender(); ppRender(); }
    if (hideLow) { var hlN = 0, hlT = setInterval(function () { if (++hlN > 20) return clearInterval(hlT); hideLowStock(); offerBoxRender(); }, 750); }
    // the buttons can render after DOMContentLoaded: retry the strip for ~15s until it is placed
    if (giftStrip) { var gsN = 0, gsT = setInterval(function () { if (++gsN > 20 || document.getElementById('lx-giftstrip')) return clearInterval(gsT); giftStripRender(); }, 750); }
    keepParams();
    // the design lazy-renders, so re-apply the copy fix as blocks arrive
    try { var _cm = new MutationObserver(function () { applyCopy(); }); _cm.observe(document.body, { subtree: true, childList: true }); } catch (e) {}
    if (endsAt) setInterval(tick, 1000);
    if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
    // re-price when the customer switches colour / size
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects, form[action="/cart/add"], .product-form, product-form')) {
        setTimeout(priceLine, 60);
        // Brian: after deleting the gift, switching back to Rose left it out AND the
        // banner still said "Free gift added". Picking a different variant is a new
        // choice, so the earlier removal no longer applies.
        REMOVED.length = 0;
        if (giftFor.length) setTimeout(function () { syncGifts(); banner(true); giftNote(); }, 120);
      }
    }, true);
    document.addEventListener('lx:gifts-added', function () {});
    try { new MutationObserver(function () { priceLine(); }).observe(document.body, { subtree: true, childList: true, characterData: true }); } catch (e) {}
    // the bundle app updates prices as text edits and switches bars by class, so both are watched
    if (bogo) {
      try { new MutationObserver(queueBogo).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] }); } catch (e) {}
      setTimeout(checkBogoCode, 3000); setInterval(checkBogoCode, 8000);
    }
  } catch (e) {}
})();

// GIFT LINES ON EVERY PAGE (23 Oct 2026, Chris: "it's only one of each, you can just click the button to add more and
// then it crashes", "maybe we have it so that you don't even have option to increase?", "if I remove the bag the free
// gifts are still there"). A gift line shows no quantity stepper anywhere (cart drawer and /cart), by variant, so it holds
// through every redraw. On a page where the campaign code above is NOT running (no link settings, e.g. /cart or a
// collection), a cart with no bag loses its free gifts and each gift stays at one per bag. Reads are one /cart.js on load
// (plus a short poll only while the cart has items); writes happen only when a gift is out of place.
(function () {
  try {
    var FREE_ALWAYS = ['47025167925295', '47015322058799', '44740616552495', '43134073045039', '47042706047023', '44740572643375', '47044500684847'];
    var KNOWN = ['45523752484911', '47015322058799', '43435014946863', '44740572643375', '47025167925295', '43453912023087',
      '44740616552495', '43134073045039', '43423814713391', '43671595483183', '44703600607279', '44606216765487', '42341584338991', '47042706047023', '47044500684847'];
    var TAGS = ['46191725576239', '46191725609007', '46191725641775', '47018722525231', '47018722557999', '47018722590767'];
    var COPY = 'LX gift copy';
    var link = [];
    try {
      var lv = new URLSearchParams(location.search).get('lxgifts') || '';
      if (/%[0-9A-Fa-f]{2}/.test(lv)) lv = decodeURIComponent(lv);
      link = lv.split(',').map(function (t) { return t.split(':')[0].trim(); }).filter(function (v) { return /^\d+$/.test(v) && TAGS.indexOf(v) === -1; });
    } catch (e) {}
    function isBag(it) {
      var cfg = (window.LXPPCart && window.LXPPCart.config) || {};
      var hp = cfg.bagHandlePattern || /^luhxe(-0)?$|^luhxe-travel-bag|^luhxe-offer/i, tp = cfg.bagTitlePattern || /travel bag/i;
      return hp.test(it.handle || '') || tp.test(it.product_title || it.title || '');
    }
    function isFreeGift(it) {
      var v = String(it.variant_id || it.id);
      if (isBag(it) || TAGS.indexOf(v) !== -1) return false;
      if (it.product_type === COPY) return true;
      return (it.final_line_price || 0) === 0 && (KNOWN.indexOf(v) !== -1 || link.indexOf(v) !== -1);
    }
    var st = document.createElement('style'); st.id = 'lx-gift-qty';
    (document.head || document.documentElement).appendChild(st);
    var hidden = {};
    function hide(ids) {
      var add = false;
      ids.forEach(function (v) { if (!hidden[v]) { hidden[v] = 1; add = true; } });
      if (!add) return;
      st.textContent = Object.keys(hidden).map(function (v) { return '.cart-item:has(a[href$="variant=' + v + '"]) quantity-input'; }).join(',') + '{display:none!important}';
    }
    hide(FREE_ALWAYS.concat(link));
    var of = window.fetch.bind(window), busy = false, lastW = 0, t = null, polls = 0, iv = null;
    function check() {
      if (busy) return;
      if (Date.now() - lastW < 1200) { clearTimeout(t); t = setTimeout(check, 1300); return; }
      busy = true;
      of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var items = cart.items || [];
        if (!items.length && iv) { clearInterval(iv); iv = null; }
        var mine = items.filter(isFreeGift);
        if (!mine.length && iv) { clearInterval(iv); iv = null; }
        hide(mine.map(function (it) { return String(it.variant_id || it.id); }));
        if (window.__lxGiftsActive) return;          // the campaign code on this page owns its gift lines
        var bags = 0; items.forEach(function (it) { if (isBag(it)) bags += (it.quantity || 0); });
        var todo = [], seen = {};
        // 29 Oct 2026 (lxreq): a gift line that came WITH a paid add-on (property _lx_req = its variant) goes when the add-on goes
        var vids = {}; items.forEach(function (it) { vids[String(it.variant_id || it.id)] = 1; });
        items.forEach(function (it) {
          var rq = it.properties && it.properties._lx_req;
          if (rq && !vids[String(rq)] && (it.final_line_price || 0) === 0) todo.push({ id: it.key, quantity: 0, req: 1 });
        });
        items.forEach(function (it) {
          if (todo.some(function (x) { return x.id === it.key; })) return;
          if (!isFreeGift(it)) return;
          if (!bags) { todo.push({ id: it.key, quantity: 0 }); return; }
          var v = String(it.variant_id || it.id), q = Math.max(0, Math.min(Math.max(1, bags) - (seen[v] || 0), it.quantity || 0));
          seen[v] = (seen[v] || 0) + q;
          if (q !== it.quantity) todo.push({ id: it.key, quantity: q });
        });
        if (!todo.length) return;
        var upd = {}; todo.forEach(function (x) { upd[x.id] = x.quantity; });
        return of('/cart/update.js?lx=1', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(function () {
          if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
          return of('/?sections=cart-drawer,cart-icon-bubble,cart-live-region-text', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); }).then(function (s) { if (window.lxSwapSections) window.lxSwapSections(s); });
        });
      }).catch(function () {}).then(function () { busy = false; });
    }
    function soon() { clearTimeout(t); t = setTimeout(check, 900); }
    try {
      if (window.PerformanceObserver) new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (e) {
          var nm = String(e.name || '');
          if (/\/cart\/(add|change|update|clear)/.test(nm) && !/[?&]lx=1/.test(nm)) { lastW = Date.now(); soon(); }
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
    if (document.readyState !== 'loading') check(); else document.addEventListener('DOMContentLoaded', check);
    iv = setInterval(function () { if (++polls > 24) { clearInterval(iv); iv = null; return; } check(); }, 5000);
  } catch (e) {}
})();

// PAID ADD-ON SHOWN IN THE CART (29 Oct 2026, Arvin: "show the subscription in the cart if the customer choose the option
// with subscription + freebies"; Kira: "doesn't mention a subscription charge anywhere"). The older Protection Plus cart layer
// (snippets/pp-cart, lxpp-cart-style) hides every membership line and stamps "<membership>: Included" on the bag, so a customer
// who took the "paid add-on + free gifts" offer never saw the add-on or its monthly price before checkout. When the cart holds
// gifts that came WITH an add-on (property _lx_req = its variant), that add-on's line is shown again, with what it costs
// ("$0.00 today, then $19.99/month. Cancel anytime."), no quantity stepper, and the bag's "Included" stamp for it is removed.
// Carts without such gifts (the Protection Plus pages) are untouched.
(function () {
  try {
    var of = window.fetch.bind(window), shown = {}, busy = false, t = null, polls = 0;
    var st = document.createElement('style'); st.id = 'lx-req-show';
    (document.head || document.documentElement).appendChild(st);
    function money(c, cur) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD' }).format((c || 0) / 100); }
      catch (e) { return '$' + ((c || 0) / 100).toFixed(2); }
    }
    function priceText(it, cur) {
      var a = it.selling_plan_allocation || {}, adj = a.price_adjustments || [];
      var first = adj.length ? adj[0].price : (a.price != null ? a.price : it.final_price);
      var later = adj.length > 1 ? adj[1].price : first;
      var unit = /week/i.test((a.selling_plan || {}).name || '') ? '/week' : /year/i.test((a.selling_plan || {}).name || '') ? '/year' : '/month';
      return (first === later ? money(later, cur) + unit : money(first, cur) + ' today, then ' + money(later, cur) + unit) + '. Cancel anytime.';
    }
    function unhide() {
      // drop the old layer's display:none for these products (it re-creates its style on some redraws, so this runs each pass)
      var hs = Object.keys(shown); if (!hs.length) return;
      document.querySelectorAll('style').forEach(function (el) {
        if (!/^lxpp-cart-style/.test(el.id || '')) return;
        var tx = el.textContent, nx = tx;
        hs.forEach(function (h) { nx = nx.split('.cart-item--product-' + h + '{display:none !important}').join(''); });
        if (nx !== tx) el.textContent = nx;
      });
    }
    function decorate() {
      unhide();
      Object.keys(shown).forEach(function (h) {
        var info = shown[h];
        var rows = [].slice.call(document.querySelectorAll('.cart-item--product-' + h));
        document.querySelectorAll('.cart-item').forEach(function (r) { if (rows.indexOf(r) === -1 && r.querySelector('a[href*="variant=' + info.v + '"]')) rows.push(r); });
        rows.forEach(function (row) {
          if (row.querySelector('.lx-req-price')) return;
          var host = row.querySelector('.cart-item__details') || row.querySelector('td:nth-child(2)') || row;
          var p = document.createElement('p'); p.className = 'lx-req-price';
          p.setAttribute('style', 'margin:4px 0 0;font-size:12.5px;line-height:1.4;color:#2b2222;font-weight:600;letter-spacing:normal;text-transform:none');
          p.textContent = info.text; host.appendChild(p);
        });
        // the bag's "Luhxe Concierge: Included" stamp contradicts the monthly charge, so it goes for this add-on
        document.querySelectorAll('.lxpp-cart-note').forEach(function (n) {
          if (n.textContent.indexOf(info.title) !== -1 && /included/i.test(n.textContent)) n.style.setProperty('display', 'none', 'important');
        });
      });
    }
    function check() {
      if (busy) return; busy = true;
      of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var items = cart.items || [], want = {};
        items.forEach(function (it) { var rq = it.properties && it.properties._lx_req; if (rq && (it.final_line_price || 0) === 0) want[String(rq)] = 1; });
        var next = {}, rules = [];
        items.forEach(function (it) {
          var v = String(it.variant_id || it.id); if (!want[v] || !it.handle) return;
          next[it.handle] = { v: v, title: it.product_title || '', text: priceText(it, cart.currency) };
          rules.push('.cart-item:has(a[href$="variant=' + v + '"]) quantity-input');
        });
        shown = next;
        st.textContent = rules.length ? rules.join(',') + '{display:none!important}' : '';
        decorate();
      }).catch(function () {}).then(function () { busy = false; });
    }
    function soon() { clearTimeout(t); t = setTimeout(check, 900); }
    try {
      if (window.PerformanceObserver) new PerformanceObserver(function (l) {
        l.getEntries().forEach(function (e) { if (/\/cart\/(add|change|update|clear)/.test(String(e.name || ''))) soon(); });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
    try {
      var mt = null;
      new MutationObserver(function () { if (!Object.keys(shown).length) return; clearTimeout(mt); mt = setTimeout(decorate, 60); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    if (document.readyState !== 'loading') check(); else document.addEventListener('DOMContentLoaded', check);
    var iv = setInterval(function () { if (++polls > 12) { clearInterval(iv); return; } check(); }, 5000);
  } catch (e) {}
})();

// HALLOWEEN PAGE HERO (23 Oct 2026, Chris: "lets use this for the hero image"). The gallery is fixed inside the GemPages
// design shared with the main page (Container-2_2.png first), so the product's own photos never reach it. On the
// Halloween page only, every copy of that first picture (the big slide, its loop clones, the thumbnail) shows Chris's
// picture instead. A link may set another with lxhero=<cdn.shopify.com image url>. snippets/lx-style-fixes.liquid keeps
// the old picture hidden until this runs, so it never flashes.
(function () {
  try {
    var HEROES = {
      'luhxe-travel-bag-2-0-halloween-bogo': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-halloween-bogo.png?v=1792697036',
      'luhxe-travel-bag-2-0-halloween-bogo-em': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-halloween-bogo.png?v=1792697036',
      // 23 Oct 2026: the 4-gifts page (no Buy 1 Get 1) uses Chris's picture with "BOGO +" taken out.
      'luhxe-travel-bag-2-0-halloween-sale': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-halloween-gifts-pp.png?v=1793181230',
      'luhxe-travel-bag-2-0-early-black-friday': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-early-black-friday.png?v=1793361243',
      'luhxe-travel-bag-2-0-early-black-friday-bogo': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-early-black-friday-bogo.png?v=1793361897',
      'luhxe-travel-bag-2-0-black-friday': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-black-friday.png?v=1793724713',
      'luhxe-travel-bag-2-0-black-friday-bogo': 'https://cdn.shopify.com/s/files/1/0607/1733/4575/files/lx-hero-black-friday-bogo.png?v=1793724718'
    };
    var H = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
    var OLD = /\/files\/Container-2_2\.png/;
    var NEW = HEROES[H] || HEROES['luhxe-travel-bag-2-0-halloween-bogo'];
    var lv = new URLSearchParams(location.search).get('lxhero') || '';
    try { if (/%[0-9A-Fa-f]{2}/.test(lv)) lv = decodeURIComponent(lv); } catch (e) {}
    var onPage = !!HEROES[H];
    if (lv && /^https:\/\/cdn\.shopify\.com\//.test(lv)) NEW = lv; else if (!onPage) return;
    var base = NEW.split('?')[0], ver = NEW.split('?')[1] || '';
    var at = function (w) { return base + '?' + (ver ? ver + '&' : '') + 'width=' + w; };
    var SET = [375, 550, 750, 1100, 1365].map(function (w) { return at(w) + ' ' + w + 'w'; }).join(', ');
    var fix = function (el) {
      var s = el.getAttribute('src') || '', ss = el.getAttribute('srcset') || '', ds = el.getAttribute('data-src') || '';
      if (!(OLD.test(s) || OLD.test(ss) || OLD.test(ds))) return;
      if (el.tagName === 'SOURCE') { el.setAttribute('srcset', SET); return; }
      el.setAttribute('srcset', SET); el.setAttribute('src', at(1365));
      if (ds) el.setAttribute('data-src', at(1365));
      el.setAttribute('alt', H === 'luhxe-travel-bag-2-0-black-friday-bogo' ? 'Black Friday: BOGO + $152 in FREE Gifts' : H === 'luhxe-travel-bag-2-0-black-friday' ? 'Black Friday: $152 in FREE Gifts' : H === 'luhxe-travel-bag-2-0-early-black-friday-bogo' ? 'Early Black Friday: BOGO + $102 in FREE Gifts' : H === 'luhxe-travel-bag-2-0-early-black-friday' ? 'Early Black Friday: $102 in FREE Gifts' : H === 'luhxe-travel-bag-2-0-halloween-sale' ? 'Halloween Sale: $102 in FREE Gifts' : 'Halloween Sale: BOGO + $102 in FREE Gifts');
    };
    var sweep = function (root) { try { (root || document).querySelectorAll('img, source').forEach(fix); } catch (e) {} };
    sweep();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          if (m.type === 'attributes') { fix(m.target); return; }
          m.addedNodes.forEach(function (n) { if (n.nodeType !== 1) return; if (/^(IMG|SOURCE)$/.test(n.tagName)) fix(n); else sweep(n); });
        });
      });
      mo.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src'] });
      setTimeout(function () { mo.disconnect(); }, 20000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sweep(); });
    window.addEventListener('load', function () { sweep(); });
  } catch (e) {}
})();

// E-GIFT CARD DELIVERY NOTE (2 Nov 2026, Kira). Shown only with the exact gift variant AND an eligible bag, matching
// the email sender's rule. A gift-only cart never sees a promise that no automation will fulfil.
(function () {
  try {
    // 03 Nov 2026 (Chris): "remove this thing that shows up in cart with description" -> note OFF. Delete this return to restore.
    if (!/[?&]lxegiftnote=1(&|$)/.test(location.search)) return;
    var GIFT = '47042706047023';
    var COPY = 'Your $25 code and Travel Guide will be emailed from support@luhxe.com after checkout. It can take a few minutes to arrive, so please check Promotions/spam. Nothing will be shipped for this item.';
    var eligible = false, busy = false, queued = false, rt = null, mt = null, polls = 0;
    function isBag(it) {
      return /^luhxe(-0)?$|^luhxe-travel-bag|^luhxe-offer/i.test(it.handle || '') || /travel bag/i.test(it.product_title || it.title || '');
    }
    function decorate() {
      if (!eligible) {
        document.querySelectorAll('.lx-egift-delivery-note').forEach(function (n) { n.remove(); });
        return;
      }
      document.querySelectorAll('.cart-item').forEach(function (row) {
        if (!row.querySelector('a[href*="variant=' + GIFT + '"]') || row.querySelector('.lx-egift-delivery-note')) return;
        var host = row.querySelector('.cart-item__details') || row.querySelector('td:nth-child(2)') || row;
        var p = document.createElement('p'); p.className = 'lx-egift-delivery-note';
        p.setAttribute('style', 'margin:6px 0 0;max-width:360px;font-size:12px;line-height:1.45;color:#666666;font-weight:400;letter-spacing:normal;text-transform:none;text-align:left');
        p.textContent = COPY; host.appendChild(p);
      });
    }
    function check() {
      if (busy) { queued = true; return; }
      busy = true;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('cart read failed');
        return r.json();
      }).then(function (cart) {
        var items = cart.items || [];
        eligible = items.some(function (it) { return String(it.variant_id || it.id) === GIFT; }) && items.some(isBag);
        decorate();
      }).catch(function () { eligible = false; decorate(); }).then(function () {
        busy = false;
        if (queued) { queued = false; check(); }
      });
    }
    function soon() { clearTimeout(rt); rt = setTimeout(check, 500); }
    try {
      if (window.PerformanceObserver) new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (/\/cart\/(add|change|update|clear)/.test(String(e.name || ''))) soon(); });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
    try {
      new MutationObserver(function () { if (!eligible) return; clearTimeout(mt); mt = setTimeout(decorate, 60); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    if (document.readyState !== 'loading') check(); else document.addEventListener('DOMContentLoaded', check);
    var iv = setInterval(function () { if (++polls > 12) { clearInterval(iv); return; } check(); }, 5000);
  } catch (e) {}
})();
